<template>
  <Transition name="modal-fade">
  <div v-if="isdisplay" class="cf-overlay" tabindex="-1">
    <div class="cf-pbi-box mt-7 mb-7 ease-out flex items-start">
      <div class="cf-pbi-content">

        <!-- ═══════════════════════════════════════════
             EN-TÊTE
        ═══════════════════════════════════════════ -->
        <div class="cf-pbi-head pbi-header">
          <div class="flex items-center gap-3 flex-1 min-w-0">
            <div class="pbi-header-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
              </svg>
            </div>
            <div class="min-w-0">
              <h6 class="modal-title text-sm font-bold leading-tight truncate">{{ titlemodal }}</h6>
              <div class="flex items-center gap-2 mt-0.5 flex-wrap">
                <span class="inline-flex items-center gap-1 text-[11px] text-gray-400 dark:text-gray-500">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  {{ datedebut }}
                </span>
                <span class="text-gray-300 dark:text-gray-600 text-xs">→</span>
                <span class="text-[11px] text-gray-400 dark:text-gray-500">{{ datefin }}</span>
                <span class="h-3 w-px bg-gray-200 dark:bg-white/10 mx-0.5"></span>
                <span class="pbi-live-badge">
                  <span class="w-1.5 h-1.5 rounded-full bg-blue-500 pbi-pulse"></span>
                  Rapport actif
                </span>
              </div>
            </div>
          </div>
          <button @click="close" type="button" class="pbi-close-btn">
            <span class="sr-only">Fermer</span>
            <svg class="w-3.5 h-3.5" viewBox="0 0 8 8" fill="none">
              <path d="M0.258206 1.00652C0.351976 0.912791 0.479126 0.860131 0.611706 0.860131C0.744296 0.860131 0.871447 0.912791 0.965207 1.00652L3.61171 3.65302L6.25822 1.00652C6.30432 0.958771 6.35952 0.920671 6.42052 0.894471C6.48152 0.868271 6.54712 0.854471 6.61352 0.853901C6.67992 0.853321 6.74572 0.865971 6.80722 0.891111C6.86862 0.916251 6.92442 0.953381 6.97142 1.00032C7.01832 1.04727 7.05552 1.1031 7.08062 1.16454C7.10572 1.22599 7.11842 1.29183 7.11782 1.35822C7.11722 1.42461 7.10342 1.49022 7.07722 1.55122C7.05102 1.61222 7.01292 1.6674 6.96522 1.71352L4.31871 4.36002L6.96522 7.00648C7.05632 7.10078 7.10672 7.22708 7.10552 7.35818C7.10442 7.48928 7.05182 7.61468 6.95912 7.70738C6.86642 7.80018 6.74102 7.85268 6.60992 7.85388C6.47882 7.85498 6.35252 7.80458 6.25822 7.71348L3.61171 5.06702L0.965207 7.71348C0.870907 7.80458 0.744606 7.85498 0.613506 7.85388C0.482406 7.85268 0.357007 7.80018 0.264297 7.70738C0.171597 7.61468 0.119017 7.48928 0.117877 7.35818C0.116737 7.22708 0.167126 7.10078 0.258206 7.00648L2.90471 4.36002L0.258206 1.71352C0.164476 1.61976 0.111816 1.4926 0.111816 1.36002C0.111816 1.22744 0.164476 1.10028 0.258206 1.00652Z" fill="currentColor"/>
            </svg>
          </button>
        </div>

        <!-- ═══════════════════════════════════════════
             CORPS
        ═══════════════════════════════════════════ -->
        <div class="cf-pbi-body">

          <!-- ── BARRE DE FILTRES ──────────────────────────────── -->
          <div class="px-4 py-3 pbi-filter-bar border-b border-gray-200 dark:border-white/[0.06]">
            <div class="flex items-end gap-3 flex-wrap">
              <div class="flex flex-col gap-1.5">
                <label class="pbi-label">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  Date début
                </label>
                <input type="date" v-model="datedebut" @change="refresh" class="pbi-input w-[145px]">
              </div>
              <div class="flex flex-col gap-1.5">
                <label class="pbi-label">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  Date fin
                </label>
                <input type="date" v-model="datefin" @change="refresh" class="pbi-input w-[145px]">
              </div>
              <div class="flex-1"></div>
              <div class="flex items-center gap-2">
                <button @click="showAdvancedFilters = !showAdvancedFilters" type="button"
                        :class="['pbi-btn-filter', showAdvancedFilters || hasActiveFilters ? 'active' : '']">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
                  </svg>
                  Filtres avancés
                  <svg :class="['transition-transform duration-200', showAdvancedFilters ? 'rotate-180' : '']"
                       width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <polyline points="6 9 12 15 18 9"/>
                  </svg>
                  <span v-if="hasActiveFilters" class="pbi-filter-badge">{{ activeFiltersCount }}</span>
                </button>
                <button @click="resetFiltres" type="button" class="pbi-btn-ghost">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.5"/>
                  </svg>
                  Réinitialiser
                </button>
              </div>
            </div>

            <transition name="expand">
              <div v-if="showAdvancedFilters"
                   class="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-5 gap-3 mt-3 pt-3 border-t border-gray-200 dark:border-white/[0.06]">
                <div class="flex flex-col gap-1.5">
                  <label class="pbi-label">Catalogue <span v-if="filtreCatalogue" class="pbi-active-tag">actif</span></label>
                  <select v-model="filtreCatalogue" class="pbi-input">
                    <option value="">- Tous -</option>
                    <option v-for="c in cataloguesDisponibles" :key="c" :value="c">{{ c }}</option>
                  </select>
                </div>
                <div class="flex flex-col gap-1.5">
                  <label class="pbi-label">Collaborateur <span v-if="filtreCollaborateur" class="pbi-active-tag">actif</span></label>
                  <select v-model="filtreCollaborateur" class="pbi-input">
                    <option value="">- Tous -</option>
                    <option v-for="c in collaborateursDisponibles" :key="c" :value="c">{{ c }}</option>
                  </select>
                </div>
                <div class="flex flex-col gap-1.5">
                  <label class="pbi-label">Article <span v-if="filtreArticle" class="pbi-active-tag">actif</span></label>
                  <input v-model="filtreArticle" type="text" placeholder="Rechercher…" class="pbi-input">
                </div>
                <div class="flex flex-col gap-1.5">
                  <label class="pbi-label">Caisse <span v-if="filtreCaisse" class="pbi-active-tag">actif</span></label>
                  <select v-model="filtreCaisse" class="pbi-input">
                    <option value="">- Toutes -</option>
                    <option v-for="c in caissesDisponibles" :key="c" :value="c">{{ c }}</option>
                  </select>
                </div>
                <div class="flex flex-col gap-1.5">
                  <label class="pbi-label">Magasin <span v-if="filtreMagasin" class="pbi-active-tag">actif</span></label>
                  <select v-model="filtreMagasin" class="pbi-input">
                    <option value="">- Tous -</option>
                    <option v-for="m in magasinsDisponibles" :key="m" :value="m">{{ m }}</option>
                  </select>
                </div>
              </div>
            </transition>
          </div>

          <!-- ── NAVIGATION ONGLETS ─────────────────────── -->
          <div class="border-b border-gray-200 dark:border-white/[0.06] bg-white dark:bg-[#0f1117]">
            <nav class="flex overflow-x-auto pbi-tabs-nav px-4" role="tablist">
              <button
                  v-for="tab in tabs"
                  :key="tab.id"
                  type="button"
                  @click="activeTab = tab.id; currentPage = 1"
                  :class="['pbi-tab', activeTab === tab.id ? 'active' : '']"
                  role="tab"
                  :aria-selected="activeTab === tab.id"
              >{{ tab.label }}</button>
            </nav>
          </div>

          <!-- ── CONTENU ONGLET ──────────────────────────── -->
          <div>

            <!-- Barre d'actions par onglet -->
            <div class="flex justify-between items-center px-4 py-2.5 border-b border-gray-100 dark:border-white/[0.04] bg-white dark:bg-[#0f1117] gap-3 flex-wrap">
              <div class="flex items-center gap-2.5 flex-wrap">
                <span class="text-[13px] font-bold text-gray-800 dark:text-gray-100">{{ activeTabLabel }}</span>
                <span class="pbi-summary-pill">{{ activeTabSummary }}</span>
              </div>
              <div class="flex items-center gap-1.5 flex-wrap">

                <!-- ── Sélecteur Vue par caisse (KPI, SYNTH, REPARTITION, BILAN) ── -->
                <template v-if="['KPI','SYNTH','REPARTITION','BILAN'].includes(activeTab)">
                  <div class="flex items-center gap-1.5">
                    <label class="pbi-label whitespace-nowrap">Vue :</label>
                    <select v-model="vueCaisse" class="pbi-input h-7 text-[11px] w-auto min-w-[120px]">
                      <option value="">Toutes les caisses</option>
                      <option v-for="c in caissesDisponibles" :key="c" :value="c">{{ c }}</option>
                    </select>
                  </div>
                  <span class="h-4 w-px bg-gray-200 dark:bg-white/10 mx-0.5"></span>
                </template>

                <!-- ── Groupement CAGA ── -->
                <template v-if="activeTab === 'CAGA'">
                  <div class="flex items-center gap-1.5">
                    <label class="pbi-label whitespace-nowrap">Grouper par :</label>
                    <select v-model="groupeCaga" class="pbi-input h-7 text-[11px] w-auto min-w-[120px]">
                      <option value="">Article (défaut)</option>
                      <option value="magasin">Magasin</option>
                      <option value="caisse">Caisse</option>
                      <option value="catalogue">Catalogue</option>
                    </select>
                  </div>
                  <span class="h-4 w-px bg-gray-200 dark:bg-white/10 mx-0.5"></span>
                </template>

                <!-- ── Filtre catégorie (DEP) ── -->
                <template v-if="activeTab === 'DEP'">
                  <div class="flex items-center gap-1.5">
                    <label class="pbi-label whitespace-nowrap">Catégorie :</label>
                    <select v-model="filtreDepCategorie" class="pbi-input h-7 text-[11px] w-auto min-w-[150px]">
                      <option value="">Toutes catégories</option>
                      <option v-for="c in categoriesDepense" :key="c" :value="c">{{ c }}</option>
                    </select>
                  </div>
                  <span class="h-4 w-px bg-gray-200 dark:bg-white/10 mx-0.5"></span>
                </template>

                <!-- ── Filtre normalisation (NORM) ── -->
                <template v-if="activeTab === 'NORM'">
                  <div class="flex items-center gap-1.5">
                    <label class="pbi-label whitespace-nowrap">Statut :</label>
                    <select v-model="filtreNormalise" class="pbi-input h-7 text-[11px] w-auto min-w-[150px]">
                      <option value="">Toutes les factures</option>
                      <option value="1">Normalisées</option>
                      <option value="0">Non normalisées</option>
                    </select>
                  </div>
                  <span class="h-4 w-px bg-gray-200 dark:bg-white/10 mx-0.5"></span>
                </template>

                <!-- ── Filtre mode de règlement (MODEREG) ── -->
                <template v-if="activeTab === 'MODEREG'">
                  <div class="flex items-center gap-1.5">
                    <label class="pbi-label whitespace-nowrap">Mode :</label>
                    <select v-model="filtreModeReg" class="pbi-input h-7 text-[11px] w-auto min-w-[150px]">
                      <option value="">Tous les modes</option>
                      <option v-for="m in modesReglement" :key="m" :value="m">{{ m }}</option>
                    </select>
                  </div>
                  <span class="h-4 w-px bg-gray-200 dark:bg-white/10 mx-0.5"></span>
                </template>

                <!-- ── Filtres suivi de stock (STOCK) ── -->
                <template v-if="activeTab === 'STOCK'">
                  <div class="flex items-center gap-1.5">
                    <label class="pbi-label whitespace-nowrap">Article :</label>
                    <select v-model="filtreStockArticle" class="pbi-input h-7 text-[11px] w-auto min-w-[160px]">
                      <option value="">Tous les articles</option>
                      <option v-for="a in articlesStock" :key="a" :value="a">{{ a }}</option>
                    </select>
                  </div>
                  <div v-if="magasinsStock.length > 1" class="flex items-center gap-1.5">
                    <label class="pbi-label whitespace-nowrap">Magasin :</label>
                    <select v-model="filtreStockMagasin" class="pbi-input h-7 text-[11px] w-auto min-w-[140px]">
                      <option value="">Tous les magasins</option>
                      <option v-for="m in magasinsStock" :key="m" :value="m">{{ m }}</option>
                    </select>
                  </div>
                  <span class="h-4 w-px bg-gray-200 dark:bg-white/10 mx-0.5"></span>
                </template>

                <!-- ── Tri / Groupement par Créé le (CAF / CADA) ── -->
                <template v-if="['CAF','CADA'].includes(activeTab)">
                  <div class="flex items-center gap-1.5">
                    <label class="pbi-label whitespace-nowrap">Trier :</label>
                    <select v-model="groupeCreele" class="pbi-input h-7 text-[11px] w-auto min-w-[170px]">
                      <option value="">Affichage simple</option>
                      <option value="creele">Grouper par le Créé le</option>
                    </select>
                  </div>
                  <span class="h-4 w-px bg-gray-200 dark:bg-white/10 mx-0.5"></span>
                </template>

                <select v-if="activeTabHasTable" v-model.number="itemsPerPage" @change="currentPage = 1"
                        class="pbi-input h-7 text-[11px]" title="Éléments par page">
                  <option :value="10">10 / page</option>
                  <option :value="20">20 / page</option>
                  <option :value="50">50 / page</option>
                  <option :value="100">100 / page</option>
                  <option :value="300">300 / page</option>
                  <option :value="999999">Tout</option>
                </select>
                <button v-if="activeTabHasTable" @click="exportCurrentTab" class="pbi-btn-excel">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                    <polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
                  </svg>
                  Excel
                </button>
                <button @click="printCurrentTab" class="pbi-btn-print">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 6 2 18 2 18 9"/>
                    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
                    <rect x="6" y="14" width="12" height="8"/>
                  </svg>
                  Imprimer
                </button>
              </div>
            </div>

            <!-- Zone imprimable -->
            <div ref="printarea" class="p-5 bg-white dark:bg-[#0f1117]">

              <!-- ░░ KPI GLOBAUX ░░ -->
              <div v-if="activeTab === 'KPI'" class="flex flex-col gap-5">

                <!-- Badge Vue filtrée si caisse sélectionnée -->
                <div v-if="vueCaisse" class="flex items-center gap-2">
                  <span class="pbi-vue-badge">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>
                    Vue filtrée : {{ vueCaisse }}
                  </span>
                  <button @click="vueCaisse=''" class="text-[10px] text-gray-400 hover:text-gray-600 underline">Voir toutes</button>
                </div>

                <!-- Cartes KPI principales -->
                <div class="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-5 gap-3">
                  <div v-for="kpi in kpiCards" :key="kpi.label" class="pbi-kpi-card">
                    <div class="pbi-kpi-accent" :style="`background:${kpi.color}`"></div>
                    <div class="pbi-kpi-icon" :style="`background:${kpi.color}1a`">
                      <div class="w-2.5 h-2.5 rounded-sm" :style="`background:${kpi.color}`"></div>
                    </div>
                    <div class="pbi-kpi-label">{{ kpi.label }}</div>
                    <div class="pbi-kpi-value" :style="`color:${kpi.color}`">{{ kpi.value }}</div>
                    <div class="pbi-kpi-sub">{{ kpi.sub }}</div>
                  </div>
                </div>

                <!-- Métriques secondaires -->
                <div class="grid grid-cols-2 lg:grid-cols-4 gap-3">
                  <div class="pbi-metric-card">
                    <div class="min-w-0">
                      <div class="pbi-metric-label">Remises accordées</div>
                      <div class="pbi-metric-value text-red-500">{{ formatMoney(kpiCurrent.totalRemises) }}</div>
                    </div>
                    <div class="pbi-metric-icon bg-red-500/10">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>
                    </div>
                  </div>
                  <div class="pbi-metric-card">
                    <div class="min-w-0">
                      <div class="pbi-metric-label">Taux remise moyen</div>
                      <div class="pbi-metric-value text-amber-500">{{ kpiCurrent.tauxRemise }}%</div>
                    </div>
                    <div class="pbi-metric-icon bg-amber-500/10">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2"><circle cx="9" cy="9" r="2"/><circle cx="15" cy="15" r="2"/><line x1="5" y1="19" x2="19" y2="5"/></svg>
                    </div>
                  </div>
                  <div class="pbi-metric-card">
                    <div class="min-w-0">
                      <div class="pbi-metric-label">Panier moyen (net)</div>
                      <div class="pbi-metric-value text-emerald-600">{{ formatMoney(kpiCurrent.panierMoyen) }}</div>
                    </div>
                    <div class="pbi-metric-icon bg-emerald-500/10">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/></svg>
                    </div>
                  </div>
                  <div class="pbi-metric-card">
                    <div class="min-w-0">
                      <div class="pbi-metric-label">Solde net</div>
                      <div class="pbi-metric-value" :style="`color:${kpiCurrent.soldeNet >= 0 ? '#16a34a' : '#ef4444'}`">{{ formatMoney(kpiCurrent.soldeNet) }}</div>
                    </div>
                    <div class="pbi-metric-icon" :style="`background:${kpiCurrent.soldeNet >= 0 ? '#16a34a1a' : '#ef44441a'}`">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" :stroke="kpiCurrent.soldeNet >= 0 ? '#16a34a' : '#ef4444'" stroke-width="2" stroke-linecap="round">
                        <polyline v-if="kpiCurrent.soldeNet >= 0" points="22 7 13.5 15.5 8.5 10.5 2 17"/>
                        <polyline v-else points="22 17 13.5 8.5 8.5 13.5 2 7"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <!-- ── KPI PAR CAISSE (tableau) ── -->
                <div v-if="!vueCaisse">
                  <div class="flex items-center gap-2 mb-3">
                    <span class="pbi-section-title">Détail par caisse</span>
                    <span class="pbi-summary-pill">{{ kpiParCaisse.length }} caisse(s)</span>
                  </div>
                  <div class="overflow-x-auto rounded-xl border border-gray-100 dark:border-white/[0.06] shadow-sm">
                    <table class="w-full border-collapse text-xs">
                      <thead>
                      <tr class="bg-gray-50 dark:bg-[#13161f]">
                        <th class="pbi-th text-left">CAISSE</th>
                        <th class="pbi-th">NB FAC.</th>
                        <th class="pbi-th">CA BRUT</th>
                        <th class="pbi-th">REMISES</th>
                        <th class="pbi-th">CA NET</th>
                        <th class="pbi-th">MARGE</th>
                        <th class="pbi-th">DÉPENSES</th>
                        <th class="pbi-th">SOLDE</th>
                        <th class="pbi-th">% CA</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(row, idx) in kpiParCaisse" :key="'kpc-'+row.caisse"
                          :class="['pbi-tr', idx % 2 !== 0 ? 'pbi-tr-alt' : '']">
                        <td class="pbi-td text-left">
                          <div class="flex items-center gap-2">
                            <span class="w-2 h-2 rounded-full flex-shrink-0" :style="`background:${getCaisseColor(row.caisse)}`"></span>
                            <span class="font-semibold text-gray-800 dark:text-gray-200">{{ row.caisse }}</span>
                          </div>
                        </td>
                        <td class="pbi-td text-center font-mono">{{ formatNumber(row.nbFactures) }}</td>
                        <td class="pbi-td text-center font-mono text-amber-600">{{ formatMoney(row.caBrut) }}</td>
                        <td class="pbi-td text-center font-mono text-red-500">{{ formatMoney(row.remises) }}</td>
                        <td class="pbi-td text-center font-mono text-emerald-600 font-bold">{{ formatMoney(row.caNet) }}</td>
                        <td class="pbi-td text-center font-mono text-blue-600">{{ formatMoney(row.marge) }}</td>
                        <td class="pbi-td text-center font-mono text-red-400">{{ formatMoney(row.depenses) }}</td>
                        <td class="pbi-td text-center font-mono font-bold" :style="`color:${row.solde >= 0 ? '#16a34a' : '#ef4444'}`">{{ formatMoney(row.solde) }}</td>
                        <td class="pbi-td text-center">
                          <div class="flex items-center gap-1.5 justify-center">
                            <div class="w-16 h-1.5 bg-gray-100 dark:bg-white/[0.05] rounded-full overflow-hidden">
                              <div class="h-full rounded-full" :style="`width:${row.pct}%;background:${getCaisseColor(row.caisse)}`"></div>
                            </div>
                            <span class="text-[10px] font-bold text-gray-500">{{ row.pct }}%</span>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr class="bg-gray-50 dark:bg-[#13161f] border-t-2 border-gray-100 dark:border-white/[0.08]">
                        <td class="px-3 py-2.5 text-[9.5px] font-bold uppercase tracking-[0.08em] text-gray-400">TOTAL</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-gray-700 dark:text-gray-200">{{ formatNumber(kpiParCaisse.reduce((s,r)=>s+r.nbFactures,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-amber-600">{{ formatMoney(kpiParCaisse.reduce((s,r)=>s+r.caBrut,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-red-500">{{ formatMoney(kpiParCaisse.reduce((s,r)=>s+r.remises,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-emerald-600">{{ formatMoney(kpiParCaisse.reduce((s,r)=>s+r.caNet,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-blue-600">{{ formatMoney(kpiParCaisse.reduce((s,r)=>s+r.marge,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-red-400">{{ formatMoney(kpiParCaisse.reduce((s,r)=>s+r.depenses,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs" :style="`color:${kpiGlobal.soldeNet >= 0 ? '#16a34a' : '#ef4444'}`">{{ formatMoney(kpiGlobal.soldeNet) }}</td>
                        <td class="px-3 py-2.5 text-center font-bold text-xs text-gray-500">100%</td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

              </div>

              <!-- ░░ RÉPARTITION CA PAR CATALOGUE ░░ -->
              <div v-else-if="activeTab === 'REPARTITION'" class="flex flex-col gap-1">
                <div v-if="vueCaisse" class="mb-3">
                  <span class="pbi-vue-badge">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>
                    Vue filtrée : {{ vueCaisse }}
                  </span>
                </div>
                <div v-if="!syntheseParCatalogueFiltered.length" class="pbi-empty-state">
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" class="mx-auto mb-3 opacity-20"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  <p class="text-sm">Aucune donnée pour les filtres sélectionnés</p>
                </div>
                <div v-for="(row, idx) in syntheseParCatalogueFiltered" :key="'rep-' + row.catalogue" class="pbi-rep-row group">
                  <span class="w-5 text-center text-[10px] font-bold text-gray-300 dark:text-gray-600 flex-shrink-0">{{ idx + 1 }}</span>
                  <span class="w-2 h-2 rounded-full flex-shrink-0" :style="`background:${getCatalogueColor(row.catalogue)}`"></span>
                  <span class="w-32 flex-shrink-0 text-[11.5px] font-semibold text-gray-700 dark:text-gray-200 truncate">{{ row.catalogue }}</span>
                  <div class="flex-1 min-w-[60px] h-2 bg-gray-100 dark:bg-white/[0.05] rounded-full overflow-hidden">
                    <div class="h-full rounded-full transition-all duration-700 min-w-[4px]"
                         :style="`width:${row.pct}%;background:${getCatalogueColor(row.catalogue)}`"></div>
                  </div>
                  <span class="w-10 text-right text-[11px] font-bold text-gray-500 flex-shrink-0">{{ row.pct }}%</span>
                  <span class="w-28 text-right text-xs font-bold font-mono flex-shrink-0" :style="`color:${getCatalogueColor(row.catalogue)}`">{{ formatMoney(row.caBrut) }}</span>
                  <div class="hidden xl:flex items-center gap-3 text-[10px] text-gray-400 flex-shrink-0">
                    <span>{{ formatNumber(row.qte) }} art.</span>
                    <span class="text-red-400">−{{ formatMoney(row.remises) }}</span>
                    <span class="text-emerald-500">{{ formatMoney(row.marge) }} marge</span>
                  </div>
                </div>
              </div>

              <!-- ░░ BILAN FINAL - DÉCOMPOSITION COMPLÈTE DU SOLDE ░░ -->
              <div v-else-if="activeTab === 'BILAN'" class="flex flex-col gap-5">

                <!-- Badge vue caisse -->
                <div v-if="vueCaisse" class="flex items-center gap-2">
                  <span class="pbi-vue-badge">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>
                    Vue filtrée : {{ vueCaisse }}
                  </span>
                  <button @click="vueCaisse=''" class="text-[10px] text-gray-400 hover:text-gray-600 underline">Voir toutes</button>
                </div>

                <!-- KPI rapides -->
                <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  <div class="pbi-kpi-card">
                    <div class="pbi-kpi-accent" style="background:#6366f1"></div>
                    <div class="pbi-kpi-label">SOLDE OUVERTURE</div>
                    <div class="pbi-kpi-value text-indigo-600">{{ formatMoney(soldeOuvertureGlobal) }}</div>
                    <div class="pbi-kpi-sub">{{ soldesOuverture.length }} caisse(s)</div>
                  </div>
                  <div class="pbi-kpi-card">
                    <div class="pbi-kpi-accent" style="background:#16a34a"></div>
                    <div class="pbi-kpi-label">VENTES NETTES</div>
                    <div class="pbi-kpi-value text-emerald-600">{{ formatMoney(bilanCurrent.caNet) }}</div>
                  </div>
                  <div class="pbi-kpi-card">
                    <div class="pbi-kpi-accent" style="background:#dc2626"></div>
                    <div class="pbi-kpi-label">TOTAL SORTIES</div>
                    <div class="pbi-kpi-value text-red-500">{{ formatMoney(
                      (ops.newarraydepense||[]).reduce((s,x)=>s+parseFloat(x.montant||0),0)
                      +(ops.newarrayRGLTFRS||[]).reduce((s,x)=>s+parseFloat(x.montant||0),0)
                      +(ops.newarrayBCDCA||[]).reduce((s,x)=>s+parseFloat(x.montant||0),0)
                    ) }}</div>
                  </div>
                  <div class="pbi-kpi-card">
                    <div class="pbi-kpi-accent" :style="`background:${soldeReel >= 0 ? '#16a34a' : '#dc2626'}`"></div>
                    <div class="pbi-kpi-label">SOLDE THÉORIQUE</div>
                    <div class="pbi-kpi-value font-extrabold" :style="`color:${soldeReel >= 0 ? '#16a34a' : '#dc2626'}`">{{ formatMoney(soldeReel) }}</div>
                  </div>
                </div>

                <!-- Tableau de décomposition par caisse -->
                <div>
                  <div class="flex items-center gap-2 mb-3">
                    <span class="pbi-section-title">Décomposition du solde par caisse</span>
                  </div>
                  <div class="overflow-x-auto rounded-xl border border-gray-100 dark:border-white/[0.06] shadow-sm">
                    <table class="w-full border-collapse text-xs">
                      <thead>
                      <tr class="bg-gray-50 dark:bg-[#13161f]">
                        <th class="pbi-th text-left">CAISSE</th>
                        <th class="pbi-th text-indigo-600">+ OUVERTURE</th>
                        <th class="pbi-th text-emerald-600">+ VENTES</th>
                        <th class="pbi-th text-amber-600">− VENTE NON ENCAISSÉE</th>
                        <th class="pbi-th text-green-700">= VENTE ENCAISSÉE</th>
                        <th class="pbi-th text-blue-600">+ APPROS</th>
                        <th class="pbi-th text-cyan-600">± TRANSFERTS</th>
                        <th class="pbi-th text-teal-600">+ RGL.CLT</th>
                        <th class="pbi-th text-sky-600">+ DÉPÔTS</th>
                        <th class="pbi-th text-lime-600">+ RETOURS</th>
                        <th class="pbi-th text-red-500">− DÉPENSES</th>
                        <th class="pbi-th text-orange-500">− RGL.FRS</th>
                        <th class="pbi-th text-rose-500">− BCDCA</th>
                        <th class="pbi-th font-bold">SOLDE</th>
                        <th class="pbi-th">STATUT</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(row, idx) in bilanDecomposition" :key="'bd-'+row.caisse"
                          :class="['pbi-tr',
                            row.isTotal ? 'bg-gray-50 dark:bg-[#13161f] border-t-2 border-gray-200 dark:border-white/10 font-bold' : (idx % 2 !== 0 ? 'pbi-tr-alt' : '')]">
                        <td class="pbi-td text-left">
                          <div class="flex items-center gap-2">
                            <span v-if="!row.isTotal" class="w-2 h-2 rounded-full flex-shrink-0" :style="`background:${getCaisseColor(row.caisse)}`"></span>
                            <span :class="['font-semibold text-gray-800 dark:text-gray-200', row.isTotal ? 'uppercase text-[9.5px] tracking-wide' : '']">{{ row.caisse }}</span>
                          </div>
                        </td>
                        <td class="pbi-td text-center font-mono text-indigo-600">{{ formatMoney(row.ouverture) }}</td>
                        <td class="pbi-td text-center font-mono text-emerald-600">{{ formatMoney(row.ventes) }}</td>
                        <td class="pbi-td text-center font-mono text-amber-600">{{ formatMoney(row.venteNonEncaissee) }}</td>
                        <td class="pbi-td text-center font-mono text-green-700 font-semibold">{{ formatMoney(row.venteEncaissee) }}</td>
                        <td class="pbi-td text-center font-mono text-blue-600">{{ formatMoney(row.appro) }}</td>
                        <td class="pbi-td text-center font-mono" :class="row.approc >= 0 ? 'text-cyan-600' : 'text-orange-500'">{{ formatMoney(row.approc) }}</td>
                        <td class="pbi-td text-center font-mono text-teal-600">{{ formatMoney(row.rglclt) }}</td>
                        <td class="pbi-td text-center font-mono text-sky-600">{{ formatMoney(row.depots) }}</td>
                        <td class="pbi-td text-center font-mono text-lime-600">{{ formatMoney(row.retours) }}</td>
                        <td class="pbi-td text-center font-mono text-red-500">{{ formatMoney(row.depenses) }}</td>
                        <td class="pbi-td text-center font-mono text-orange-500">{{ formatMoney(row.rglfrs) }}</td>
                        <td class="pbi-td text-center font-mono text-rose-500">{{ formatMoney(row.bcdca) }}</td>
                        <td class="pbi-td text-center font-mono font-bold text-sm" :style="`color:${row.solde >= 0 ? '#16a34a' : '#ef4444'}`">{{ formatMoney(row.solde) }}</td>
                        <td class="pbi-td text-center">
                          <span v-if="!row.isTotal" :class="['pbi-status-badge', row.solde >= 0 ? 'positive' : 'negative']">
                            {{ row.solde >= 0 ? 'Créditeur' : 'Déficitaire' }}
                          </span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Bilan par catalogue (inchangé) -->
                <div>
                  <div class="flex items-center gap-2 mb-3">
                    <span class="pbi-section-title">Bilan par catalogue</span>
                  </div>
                  <div class="overflow-x-auto rounded-xl border border-gray-100 dark:border-white/[0.06] shadow-sm">
                    <table class="w-full border-collapse text-xs">
                      <thead>
                      <tr class="bg-gray-50 dark:bg-[#13161f]">
                        <th class="pbi-th text-left">CATALOGUE</th>
                        <th class="pbi-th">NB ART.</th>
                        <th class="pbi-th">QTÉ</th>
                        <th class="pbi-th">CA BRUT</th>
                        <th class="pbi-th">REMISES</th>
                        <th class="pbi-th">CA NET</th>
                        <th class="pbi-th">MARGE</th>
                        <th class="pbi-th">% CA</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(row, idx) in syntheseParCatalogueFiltered" :key="'bcat-'+row.catalogue"
                          :class="['pbi-tr', idx % 2 !== 0 ? 'pbi-tr-alt' : '']">
                        <td class="pbi-td text-left">
                          <div class="flex items-center gap-2">
                            <span class="w-2 h-2 rounded-full flex-shrink-0" :style="`background:${getCatalogueColor(row.catalogue)}`"></span>
                            <span class="font-semibold text-gray-800 dark:text-gray-200">{{ row.catalogue }}</span>
                          </div>
                        </td>
                        <td class="pbi-td text-center font-mono">{{ formatNumber(row.nbArticles) }}</td>
                        <td class="pbi-td text-center font-mono">{{ formatNumber(row.qte) }}</td>
                        <td class="pbi-td text-center font-mono text-amber-600">{{ formatMoney(row.caBrut) }}</td>
                        <td class="pbi-td text-center font-mono text-red-500">{{ formatMoney(row.remises) }}</td>
                        <td class="pbi-td text-center font-mono text-emerald-600 font-bold">{{ formatMoney(row.caNet) }}</td>
                        <td class="pbi-td text-center font-mono text-blue-600">{{ formatMoney(row.marge) }}</td>
                        <td class="pbi-td text-center">
                          <div class="flex items-center gap-1.5 justify-center">
                            <div class="w-12 h-1.5 bg-gray-100 dark:bg-white/[0.05] rounded-full overflow-hidden">
                              <div class="h-full rounded-full" :style="`width:${row.pct}%;background:${getCatalogueColor(row.catalogue)}`"></div>
                            </div>
                            <span class="text-[10px] font-bold text-gray-500">{{ row.pct }}%</span>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr class="bg-gray-50 dark:bg-[#13161f] border-t-2 border-gray-100 dark:border-white/[0.08]">
                        <td class="px-3 py-2.5 text-[9.5px] font-bold uppercase tracking-[0.08em] text-gray-400">TOTAL</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs">{{ formatNumber(syntheseParCatalogueFiltered.reduce((s,r)=>s+r.nbArticles,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs">{{ formatNumber(syntheseParCatalogueFiltered.reduce((s,r)=>s+r.qte,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-amber-600">{{ formatMoney(syntheseParCatalogueFiltered.reduce((s,r)=>s+r.caBrut,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-red-500">{{ formatMoney(syntheseParCatalogueFiltered.reduce((s,r)=>s+r.remises,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-emerald-600">{{ formatMoney(syntheseParCatalogueFiltered.reduce((s,r)=>s+r.caNet,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-blue-600">{{ formatMoney(syntheseParCatalogueFiltered.reduce((s,r)=>s+r.marge,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-bold text-xs text-gray-500">100%</td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

              </div>

              <!-- ░░ TABLEAUX GÉNÉRIQUES ░░ -->
              <template v-else>

                <!-- ── KPI Factures / Avoirs - visibles uniquement sur CAF et CADA ── -->
                <div v-if="['CAF','CADA'].includes(activeTab)"
                     class="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">

                  <!-- Factures F -->
                  <div class="pbi-kpi-card">
                    <div class="pbi-kpi-accent" style="background:#16a34a"></div>
                    <div class="pbi-kpi-icon" style="background:#16a34a1a">
                      <div class="w-2.5 h-2.5 rounded-sm" style="background:#16a34a"></div>
                    </div>
                    <div class="pbi-kpi-label">FACTURES (F)</div>
                    <div class="pbi-kpi-value text-emerald-600">{{ formatMoney(kpiFactures.montantF) }}</div>
                    <div class="pbi-kpi-sub">{{ kpiFactures.nbF }} facture(s)</div>
                  </div>

                  <!-- Avoirs BR -->
                  <div class="pbi-kpi-card">
                    <div class="pbi-kpi-accent" style="background:#dc2626"></div>
                    <div class="pbi-kpi-icon" style="background:#dc26261a">
                      <div class="w-2.5 h-2.5 rounded-sm" style="background:#dc2626"></div>
                    </div>
                    <div class="pbi-kpi-label">AVOIRS / ANNULATIONS (BR)</div>
                    <div class="pbi-kpi-value text-red-500">− {{ formatMoney(kpiFactures.montantBR_affiche) }}</div>
                    <div class="pbi-kpi-sub">{{ kpiFactures.nbBR }} avoir(s)</div>
                  </div>

                  <!-- Remises -->
                  <div class="pbi-kpi-card">
                    <div class="pbi-kpi-accent" style="background:#f59e0b"></div>
                    <div class="pbi-kpi-icon" style="background:#f59e0b1a">
                      <div class="w-2.5 h-2.5 rounded-sm" style="background:#f59e0b"></div>
                    </div>
                    <div class="pbi-kpi-label">REMISES ACCORDÉES</div>
                    <div class="pbi-kpi-value text-amber-500">{{ formatMoney(kpiFactures.remise) }}</div>
                    <div class="pbi-kpi-sub">Total sur ventes (F)</div>
                  </div>

                  <!-- CA Net = F − BR -->
                  <div class="pbi-kpi-card">
                    <div class="pbi-kpi-accent"
                         :style="`background:${kpiFactures.caNet >= 0 ? '#2563eb' : '#dc2626'}`"></div>
                    <div class="pbi-kpi-icon"
                         :style="`background:${kpiFactures.caNet >= 0 ? '#2563eb1a' : '#dc26261a'}`">
                      <div class="w-2.5 h-2.5 rounded-sm"
                           :style="`background:${kpiFactures.caNet >= 0 ? '#2563eb' : '#dc2626'}`"></div>
                    </div>
                    <div class="pbi-kpi-label">CA NET (F − BR)</div>
                    <div class="pbi-kpi-value font-extrabold"
                         :style="`color:${kpiFactures.caNet >= 0 ? '#2563eb' : '#dc2626'}`">
                      {{ formatMoney(kpiFactures.caNet) }}
                    </div>
                    <div class="pbi-kpi-sub">Après avoirs</div>
                  </div>

                </div>
                <!-- ── fin KPI Factures ── -->

                <!-- ── Récap Montant par catégorie (DEP) ── -->
                <div v-if="activeTab === 'DEP' && depenseParCategorie.length" class="mb-4">
                  <div class="flex items-center gap-2 mb-2">
                    <span class="pbi-section-title">Montant par catégorie</span>
                  </div>
                  <div class="overflow-x-auto rounded-xl border border-gray-100 dark:border-white/[0.06] shadow-sm">
                    <table class="w-full border-collapse text-xs">
                      <thead>
                      <tr class="bg-gray-50 dark:bg-[#13161f]">
                        <th class="pbi-th text-left">CATÉGORIE</th>
                        <th class="pbi-th">NB</th>
                        <th class="pbi-th">MONTANT</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(row, idx) in depenseParCategorie" :key="'depcat-'+row.categorie"
                          :class="['pbi-tr', idx % 2 !== 0 ? 'pbi-tr-alt' : '']">
                        <td class="pbi-td text-left font-semibold text-gray-800 dark:text-gray-200">{{ row.categorie }}</td>
                        <td class="pbi-td text-center font-mono">{{ formatNumber(row.nb) }}</td>
                        <td class="pbi-td text-center font-mono text-red-500">{{ formatMoney(row.montant) }}</td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr class="bg-gray-50 dark:bg-[#13161f] border-t-2 border-gray-100 dark:border-white/[0.08]">
                        <td class="px-3 py-2.5 text-[9.5px] font-bold uppercase tracking-[0.08em] text-gray-400">TOTAL DÉPENSES</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs">{{ formatNumber(depenseParCategorie.reduce((s,r)=>s+r.nb,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-red-500">{{ formatMoney(depenseParCategorie.reduce((s,r)=>s+r.montant,0)) }}</td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <!-- ── Récap Point normalisation (NORM) ── -->
                <div v-if="activeTab === 'NORM'" class="mb-4">
                  <div class="flex items-center gap-2 mb-2">
                    <span class="pbi-section-title">Point normalisation</span>
                  </div>
                  <div class="overflow-x-auto rounded-xl border border-gray-100 dark:border-white/[0.06] shadow-sm">
                    <table class="w-full border-collapse text-xs">
                      <thead>
                      <tr class="bg-gray-50 dark:bg-[#13161f]">
                        <th class="pbi-th text-left">STATUT</th>
                        <th class="pbi-th">NB FACTURES</th>
                        <th class="pbi-th">MONTANT TOTAL</th>
                        <th class="pbi-th">MONTANT RESTANT</th>
                        <th class="pbi-th">ENCAISSÉ</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(row, idx) in pointNormalisation" :key="'norm-'+row.statut"
                          :class="['pbi-tr', idx % 2 !== 0 ? 'pbi-tr-alt' : '']">
                        <td class="pbi-td text-left font-semibold text-gray-800 dark:text-gray-200">{{ row.statut }}</td>
                        <td class="pbi-td text-center font-mono">{{ formatNumber(row.nbFactures) }}</td>
                        <td class="pbi-td text-center font-mono text-emerald-600">{{ formatMoney(row.montant) }}</td>
                        <td class="pbi-td text-center font-mono text-amber-600">{{ formatMoney(row.restant) }}</td>
                        <td class="pbi-td text-center font-mono text-green-700 font-semibold">{{ formatMoney(row.encaisse) }}</td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr class="bg-gray-50 dark:bg-[#13161f] border-t-2 border-gray-100 dark:border-white/[0.08]">
                        <td class="px-3 py-2.5 text-[9.5px] font-bold uppercase tracking-[0.08em] text-gray-400">TOTAL</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs">{{ formatNumber(pointNormalisation.reduce((s,r)=>s+r.nbFactures,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-emerald-600">{{ formatMoney(pointNormalisation.reduce((s,r)=>s+r.montant,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-amber-600">{{ formatMoney(pointNormalisation.reduce((s,r)=>s+r.restant,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-green-700">{{ formatMoney(pointNormalisation.reduce((s,r)=>s+r.encaisse,0)) }}</td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <!-- ── Récap Montant par mode (MODEREG) ── -->
                <div v-if="activeTab === 'MODEREG' && pointModeReglement.length" class="mb-4">
                  <div class="flex items-center gap-2 mb-2">
                    <span class="pbi-section-title">Montant par mode de règlement</span>
                  </div>
                  <div class="overflow-x-auto rounded-xl border border-gray-100 dark:border-white/[0.06] shadow-sm">
                    <table class="w-full border-collapse text-xs">
                      <thead>
                      <tr class="bg-gray-50 dark:bg-[#13161f]">
                        <th class="pbi-th text-left">MODE</th>
                        <th class="pbi-th">NB FACTURES</th>
                        <th class="pbi-th">MONTANT TOTAL</th>
                        <th class="pbi-th">MONTANT RESTANT</th>
                        <th class="pbi-th">ENCAISSÉ</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(row, idx) in pointModeReglement" :key="'mode-'+row.mode"
                          :class="['pbi-tr', idx % 2 !== 0 ? 'pbi-tr-alt' : '']">
                        <td class="pbi-td text-left font-semibold text-gray-800 dark:text-gray-200">{{ row.mode }}</td>
                        <td class="pbi-td text-center font-mono">{{ formatNumber(row.nbFactures) }}</td>
                        <td class="pbi-td text-center font-mono text-emerald-600">{{ formatMoney(row.montant) }}</td>
                        <td class="pbi-td text-center font-mono text-amber-600">{{ formatMoney(row.restant) }}</td>
                        <td class="pbi-td text-center font-mono text-green-700 font-semibold">{{ formatMoney(row.encaisse) }}</td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr class="bg-gray-50 dark:bg-[#13161f] border-t-2 border-gray-100 dark:border-white/[0.08]">
                        <td class="px-3 py-2.5 text-[9.5px] font-bold uppercase tracking-[0.08em] text-gray-400">TOTAL</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs">{{ formatNumber(pointModeReglement.reduce((s,r)=>s+r.nbFactures,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-emerald-600">{{ formatMoney(pointModeReglement.reduce((s,r)=>s+r.montant,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-amber-600">{{ formatMoney(pointModeReglement.reduce((s,r)=>s+r.restant,0)) }}</td>
                        <td class="px-3 py-2.5 text-center font-mono font-bold text-xs text-green-700">{{ formatMoney(pointModeReglement.reduce((s,r)=>s+r.encaisse,0)) }}</td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <div class="overflow-x-auto rounded-xl border border-gray-100 dark:border-white/[0.06] shadow-sm">
                  <table ref="activetable" class="w-full border-collapse text-xs">
                    <thead>
                    <tr class="bg-gray-50 dark:bg-[#13161f]">
                      <th v-for="col in activeTabColumns" :key="col.key"
                          :class="['pbi-th', col.align === 'left' ? 'text-left' : 'text-center']">
                        {{ col.label }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-if="activeTabData.length">
                      <!-- Lignes de groupe (CAGA groupé) -->
                      <template v-if="activeTab === 'CAGA' && groupeCaga">
                        <template v-for="grp in caGlobalGroupe" :key="'grp-'+grp.groupe">
                          <tr class="pbi-tr-group">
                            <td :colspan="activeTabColumns.length" class="pbi-td-group">
                              <div class="flex items-center gap-2">
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
                                <span class="font-bold text-gray-700 dark:text-gray-200">{{ grp.groupe }}</span>
                                <span class="pbi-summary-pill">{{ grp.lignes.length }} article(s) · {{ formatMoney(grp.totalMontant) }}</span>
                              </div>
                            </td>
                          </tr>
                          <tr v-for="(row, idx) in grp.lignes" :key="'caga-'+idx"
                              :class="['pbi-tr pbi-tr-sub', idx % 2 !== 0 ? 'pbi-tr-alt' : '']">
                            <td v-for="col in activeTabColumns" :key="col.key"
                                :class="['pbi-td', col.align === 'left' ? 'text-left font-sans text-[11.5px] text-gray-800 dark:text-gray-200' : 'text-center font-mono text-[11px] text-gray-600 dark:text-gray-300', col.type === 'money' && parseFloat(row[col.key]||0) < 0 ? '!text-red-500' : '']">
                              <template v-if="col.type === 'money'">{{ formatMoney(row[col.key]) }}</template>
                              <template v-else-if="col.type === 'number'">{{ formatNumber(row[col.key]) }}</template>
                              <template v-else-if="col.type === 'percent'">{{ row[col.key] }}%</template>
                              <template v-else>{{ row[col.key] !== undefined && row[col.key] !== null && row[col.key] !== '' ? row[col.key] : '-' }}</template>
                            </td>
                          </tr>
                        </template>
                      </template>

                      <!-- Lignes groupées par Créé le (CAF / CADA) -->
                      <template v-else-if="['CAF','CADA'].includes(activeTab) && groupeCreele">
                        <template v-for="grp in creeleGroupe" :key="'clgrp-'+grp.groupe">
                          <tr class="pbi-tr-group">
                            <td :colspan="activeTabColumns.length" class="pbi-td-group">
                              <div class="flex items-center gap-2">
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                                <span class="font-bold text-gray-700 dark:text-gray-200">{{ grp.groupe }}</span>
                                <span class="pbi-summary-pill">{{ grp.lignes.length }} ligne(s) · {{ formatMoney(grp.totalMontant) }}</span>
                              </div>
                            </td>
                          </tr>
                          <tr v-for="(row, idx) in grp.lignes" :key="'cl-'+grp.groupe+'-'+idx"
                              :class="['pbi-tr pbi-tr-sub', idx % 2 !== 0 ? 'pbi-tr-alt' : '']">
                            <td v-for="col in activeTabColumns" :key="col.key"
                                :class="['pbi-td', col.align === 'left' ? 'text-left font-sans text-[11.5px] text-gray-800 dark:text-gray-200' : 'text-center font-mono text-[11px] text-gray-600 dark:text-gray-300', col.type === 'money' && parseFloat(row[col.key]||0) < 0 ? '!text-red-500' : '']">
                              <!-- typeDocument F=vert / BR=rouge -->
                              <template v-if="col.key === 'typeDocument'">
                                <span :class="[
                                  'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold',
                                  row.doctyp === 'BR'
                                    ? 'bg-red-50 text-red-600 dark:bg-red-900/20 dark:text-red-400'
                                    : 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-400'
                                ]">
                                  <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
                                        :class="row.doctyp === 'BR' ? 'bg-red-500' : 'bg-emerald-500'"></span>
                                  {{ row[col.key] }}
                                </span>
                              </template>
                              <template v-else-if="col.key === 'createdat_display'">
                                <div class="flex flex-col leading-tight">
                                  <span class="text-[10.5px] font-medium text-gray-700 dark:text-gray-200">{{ fmtCreatedDate(row) }}</span>
                                  <span class="text-[9.5px] text-gray-400">{{ fmtCreatedTime(row) }}</span>
                                </div>
                              </template>
                              <template v-else-if="col.type === 'money'">{{ formatMoney(row[col.key]) }}</template>
                              <template v-else-if="col.type === 'number'">{{ formatNumber(row[col.key]) }}</template>
                              <template v-else-if="col.type === 'percent'">{{ row[col.key] }}%</template>
                              <template v-else>{{ row[col.key] !== undefined && row[col.key] !== null && row[col.key] !== '' ? row[col.key] : '-' }}</template>
                            </td>
                          </tr>
                        </template>
                      </template>

                      <!-- Lignes normales -->
                      <template v-else>
                        <tr v-for="(row, idx) in paginatedData" :key="idx"
                            :class="['pbi-tr', idx % 2 !== 0 ? 'pbi-tr-alt' : '']">
                          <td v-for="col in activeTabColumns" :key="col.key"
                              :class="[
                                    'pbi-td',
                                    col.align === 'left' ? 'text-left font-sans text-[11.5px] text-gray-800 dark:text-gray-200' : 'text-center font-mono text-[11px] text-gray-600 dark:text-gray-300',
                                    col.type === 'money' && parseFloat(row[col.key]||0) < 0 ? '!text-red-500' : '',
                                    col.key === 'qtstck_avant' ? 'text-blue-500' : '',
                                    col.key === 'qtstck_apres' ? '!font-bold' : '',
                                    col.key === 'stockDiff' && row[col.key] < 0 ? '!text-red-500' : '',
                                    col.key === 'oldquantite' ? 'text-gray-400 line-through' : '',
                                  ]">
                            <!-- Rendu spécial typeDocument (F=vert, BR=rouge) -->
                            <template v-if="col.key === 'typeDocument'">
                              <span :class="[
                                'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold',
                                row.doctyp === 'BR'
                                  ? 'bg-red-50 text-red-600 dark:bg-red-900/20 dark:text-red-400'
                                  : 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-400'
                              ]">
                                <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
                                      :class="row.doctyp === 'BR' ? 'bg-red-500' : 'bg-emerald-500'"></span>
                                {{ row[col.key] }}
                              </span>
                            </template>
                            <!-- Rendu spécial pour les colonnes stock -->
                            <template v-else-if="col.key === 'stockDiff'">
                                <span :class="['inline-flex items-center gap-0.5 font-bold', row[col.key] < 0 ? 'text-red-500' : 'text-emerald-500']">
                                  {{ row[col.key] > 0 ? '+' : '' }}{{ formatNumber(row[col.key]) }}
                                </span>
                            </template>
                            <!-- Rendu spécial createdAt -->
                            <template v-else-if="col.key === 'createdat_display'">
                              <div class="flex flex-col leading-tight">
                                <span class="text-[10.5px] font-medium text-gray-700 dark:text-gray-200">{{ fmtCreatedDate(row) }}</span>
                                <span class="text-[9.5px] text-gray-400">{{ fmtCreatedTime(row) }}</span>
                              </div>
                            </template>
                            <template v-else-if="col.type === 'money'">{{ formatMoney(row[col.key]) }}</template>
                            <template v-else-if="col.type === 'number'">{{ formatNumber(row[col.key]) }}</template>
                            <template v-else-if="col.type === 'percent'">{{ row[col.key] }}%</template>
                            <template v-else>{{ row[col.key] !== undefined && row[col.key] !== null && row[col.key] !== '' ? row[col.key] : '-' }}</template>
                          </td>
                        </tr>
                      </template>

                    </template>
                    <template v-else>
                      <tr>
                        <td :colspan="activeTabColumns.length" class="py-14 text-center">
                          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" class="mx-auto mb-3 opacity-20">
                            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                          </svg>
                          <p class="text-sm text-gray-400">Aucune donnée pour les filtres sélectionnés</p>
                        </td>
                      </tr>
                    </template>
                    </tbody>
                    <tfoot v-if="activeTabData.length">
                    <tr class="bg-gray-50 dark:bg-[#13161f] border-t-2 border-gray-100 dark:border-white/[0.08]">
                      <td v-for="(col, colIdx) in activeTabColumns" :key="col.key"
                          :class="['px-3 py-2.5 font-bold text-[11px]', colIdx === 0 ? 'text-left text-[9.5px] uppercase tracking-[0.08em] text-gray-400 font-sans' : 'text-center font-mono text-gray-800 dark:text-gray-200']">
                        <template v-if="colIdx === 0">TOTAL</template>
                        <template v-else-if="col.type === 'money'">{{ formatMoney(activeTabTotals[col.key] || 0) }}</template>
                        <template v-else-if="col.type === 'number'">{{ formatNumber(activeTabTotals[col.key] || 0) }}</template>
                        <template v-else-if="col.type === 'percent'">100%</template>
                        <template v-else></template>
                      </td>
                    </tr>
                    </tfoot>
                  </table>
                </div>

                <!-- Pagination -->
                <div v-if="totalPages > 1 && !(activeTab === 'CAGA' && groupeCaga) && !(['CAF','CADA'].includes(activeTab) && groupeCreele)" class="pbi-no-print flex justify-between items-center pt-3 flex-wrap gap-2">
                  <span class="text-[11px] text-gray-400">
                    <span class="font-semibold text-gray-600 dark:text-gray-300">
                      {{ (currentPage - 1) * itemsPerPage + 1 }}-{{ Math.min(currentPage * itemsPerPage, activeTabData.length) }}
                    </span>
                    sur {{ activeTabData.length }} résultat(s)
                  </span>
                  <div class="flex items-center gap-1.5">
                    <button @click="currentPage--" :disabled="currentPage === 1" class="pbi-page-btn">‹ Préc.</button>
                    <div class="flex items-center gap-1">
                      <span class="px-3 py-1.5 rounded-lg bg-blue-500 text-white text-[11px] font-bold">{{ currentPage }}</span>
                      <span class="text-[11px] text-gray-400">/</span>
                      <span class="px-2 py-1.5 text-[11px] text-gray-500">{{ totalPages }}</span>
                    </div>
                    <button @click="currentPage++" :disabled="currentPage === totalPages" class="pbi-page-btn">Suiv. ›</button>
                  </div>
                </div>
              </template>

            </div><!-- /printarea -->
          </div>
        </div><!-- /cf-pbi-body -->

        <!-- ── PIED ───────────────────────────────────── -->
        <div class="cf-pbi-foot bg-gray-50 dark:bg-[#0a0d14] border-t border-gray-100 dark:border-white/[0.06]">
          <button type="button" @click="close" class="ti-btn ti-btn-light align-middle">Fermer</button>
        </div>

      </div><!-- /cf-pbi-content -->
    </div><!-- /cf-pbi-box -->
  </div>
  </Transition>
</template>

<script>
/* eslint-disable */
import {
  currencyFormatDE,
  currentDate, currentDateTime,
  ExportExcel, FormatNumber,
  impression, isValidDateString,
  randomString
} from "@/allfunction";
import * as JwtService from "@/common/jwt.service";
import { imprimerRapport, enteteRapport } from "@/service/impressionRapport";

const axios = require('axios');

// ═══════════════════════════════════════════════════════════════════
// Utilitaire : parse un createdat ISO ou string en { date, time }
// ═══════════════════════════════════════════════════════════════════
function parseCreatedAt(val) {
  if (!val) return { createdat_date: '', createdat_time: '' };
  if (val instanceof Date) {
    return {
      createdat_date: val.toISOString().substring(0, 10),
      createdat_time: val.toISOString().substring(11, 16),
    };
  }
  const str = String(val).trim();
  const m = str.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/);
  if (m) return { createdat_date: m[1], createdat_time: m[2] };
  const d = str.match(/^(\d{4}-\d{2}-\d{2})/);
  if (d) return { createdat_date: d[1], createdat_time: '' };
  return { createdat_date: str, createdat_time: '' };
}

const MOCK_DATA = {
  ventes: [

  
  ],
  depenses: [
 ]
};

export default {
  /* eslint-disable */
  name: "modal_rapportdecaisse_6",

  watch: {
    // activeTab : déjà réinitialisé dans @click du template → watch supprimé
    groupeCaga()   { this.currentPage = 1; },
    vueCaisse()    { this.currentPage = 1; },
    groupeCreele() { this.currentPage = 1; },
    filtreDepCategorie() { this.currentPage = 1; },
    filtreNormalise()    { this.currentPage = 1; },
    filtreModeReg()      { this.currentPage = 1; },
    filtreStockArticle() { this.currentPage = 1; },
    filtreStockMagasin() { this.currentPage = 1; },
  },

  computed: {

    // ══════════════════════════════════════════════════════════════════════════
    // COMPUTED - OPÉRATIONS CAISSE (données enrichies V2)
    // ══════════════════════════════════════════════════════════════════════════

    // ── Raccourci vers le bloc operations ────────────────────────────────────
    ops() { return this.datatable.ops || {}; },

    // ── Soldes à l'ouverture (une entrée par caisse) ─────────────────────────
    soldesOuverture() {
      return this.ops.newarraySOLDEALOUVERTURE || [];
    },
    soldeOuvertureGlobal() {
      return this.soldesOuverture.reduce((s, x) => s + parseFloat(x.montant || 0), 0);
    },

    // ── Solde réel théorique de la caisse ────────────────────────────────────
    // Formule :
    //   + Solde ouverture
    //   + Ventes nettes (F signé positif, BR signé négatif)
    //   + Appros banque (toujours positif)
    //   + Transferts inter-caisses (déjà signés : +reçu, −envoyé)
    //   + Règlements clients (positif)
    //   + Dépôts clients (déjà signés)
    //   + Retours de fonds (déjà signés)
    //   − Dépenses (positif = dépense, négatif = annulation → soustraction)
    //   − Règlements fournisseurs (positif)
    //   − BCDCA (positif)
    soldeReel() {
      return (
        this.soldeOuvertureGlobal
        + (this.ops.CAparfactureparcollaborateur || [])
            .reduce((s, x) => s + parseFloat(x.montanttotal || 0), 0)
        + (this.ops.arrayAPPRO || [])
            .reduce((s, x) => s + parseFloat(x.cmontant || 0), 0)
        + (this.ops.arrayAPPROC || [])
            .reduce((s, x) => s + parseFloat(x.cmontant || 0), 0)
        + (this.ops.newarrayRGLTCLT || [])
            .reduce((s, x) => s + parseFloat(x.montant || 0), 0)
        + (this.ops.newarrayDEPOTCLIENT || [])
            .reduce((s, x) => s + parseFloat(x.montant || 0), 0)
        + (this.ops.newarrayREF || [])
            .reduce((s, x) => s + parseFloat(x.montant || 0), 0)
        - (this.ops.newarraydepense || [])
            .reduce((s, x) => s + parseFloat(x.montant || 0), 0)
        - (this.ops.newarrayRGLTFRS || [])
            .reduce((s, x) => s + parseFloat(x.montant || 0), 0)
        - (this.ops.newarrayBCDCA || [])
            .reduce((s, x) => s + parseFloat(x.montant || 0), 0)
      );
    },

    // ── Opérations de caisse (OPC) ───────────────────────────────────────────
    opcData() {
      const appro = (this.ops.arrayAPPRO || []).map(x => ({
        typeoperation : 'Appro. banque',
        dateop        : x.datop || '',
        numdoc        : x.numdoc || '',
        nomcaisse     : x.caisse || '',
        caissedebiteur: '',
        caissecrediteur: x.caisse || '',
        banque        : x.banque || '',
        beneficiaire  : x.saisirpar || '',
        motif         : x.motif || '',
        montant       : parseFloat(x.cmontant || 0),
      }));
      const approc = (this.ops.arrayAPPROC || []).map(x => ({
        typeoperation : parseFloat(x.cmontant || 0) >= 0
                          ? 'Transfert reçu' : 'Transfert envoyé',
        dateop        : x.datop || '',
        numdoc        : x.numdoc || '',
        nomcaisse     : x.caissecrediteur || x.caisse || '',
        caissedebiteur: (x.caissedebiteur || '').replace(/\.\.\.$/,''),
        caissecrediteur: x.caissecrediteur || '',
        banque        : '',
        beneficiaire  : x.saisirpar || '',
        motif         : x.motif || '',
        montant       : parseFloat(x.cmontant || 0),
      }));
      const ref = (this.ops.newarrayREF || []).map(x => ({
        typeoperation : parseFloat(x.montant || 0) >= 0
                          ? 'Retour de fonds' : 'Annul. retour fonds',
        dateop        : x.dateop || '',
        numdoc        : x.numdoc || '',
        nomcaisse     : x.nomcaisse || '',
        caissedebiteur: '',
        caissecrediteur: '',
        banque        : '',
        beneficiaire  : x.beneficiaire || '',
        motif         : (x.motif || '').substring(0, 80),
        montant       : parseFloat(x.montant || 0),
      }));
      const dpcc = (this.ops.newarrayDEPOTCLIENT || []).map(x => ({
        typeoperation : parseFloat(x.montant || 0) >= 0
                          ? 'Dépôt client' : 'Annul. dépôt client',
        dateop        : x.dateop || '',
        numdoc        : x.numdoc || '',
        nomcaisse     : x.nomcaisse || '',
        caissedebiteur: '',
        caissecrediteur: '',
        banque        : '',
        beneficiaire  : x.beneficiaire || '',
        motif         : '',
        montant       : parseFloat(x.montant || 0),
      }));
      return [...appro, ...approc, ...ref, ...dpcc]
        .sort((a, b) => (a.dateop || '').localeCompare(b.dateop || ''));
    },

    // ── Règlements clients (RGLCLT) ──────────────────────────────────────────
    rglcltData() {
      return (this.ops.newarrayRGLTCLT || []).map(x => ({
        typeoperation: x.ligne === 'REGCLT' ? 'Règlement client'
                     : x.ligne === 'AVCCLT' ? 'Avance client' : x.ligne,
        dateop       : x.dateop || '',
        numdoc       : x.numdoc || '',
        nomcaisse    : x.nomcaisse || '',
        beneficiaire : x.beneficiaire || '',
        montant      : parseFloat(x.montant || 0),
      })).sort((a, b) => (a.dateop || '').localeCompare(b.dateop || ''));
    },

    // ── Règlements fournisseurs + BCDCA (RGLFRS) ─────────────────────────────
    rglfrsData() {
      const frs = (this.ops.newarrayRGLTFRS || []).map(x => ({
        typeoperation: x.ligne === 'REGFRS' ? 'Règlement fournisseur'
                     : x.ligne === 'AVCFRS' ? 'Avance fournisseur' : x.ligne,
        dateop       : x.dateop || '',
        numdoc       : x.numdoc || '',
        nomcaisse    : x.nomcaisse || '',
        beneficiaire : x.beneficiaire || '',
        montant      : parseFloat(x.montant || 0),
      }));
      const bcdca = (this.ops.newarrayBCDCA || []).map(x => ({
        typeoperation: 'BCDCA',
        dateop       : x.dateop || '',
        numdoc       : x.numdoc || '',
        nomcaisse    : x.nomcaisse || '',
        beneficiaire : x.beneficiaire || '',
        montant      : parseFloat(x.montant || 0),
      }));
      return [...frs, ...bcdca].sort((a, b) => (a.dateop || '').localeCompare(b.dateop || ''));
    },

    // ── Dépenses filtrées date + caisse (avant filtre catégorie) ──────────────
    depensesBase() {
      const enrichie = this.ops.newarraydepense || [];
      if (enrichie.length > 0) {
        let data = [...enrichie];
        if (this.datedebut) data = data.filter(x => (x.dateop || '') >= this.datedebut);
        if (this.datefin)   data = data.filter(x => (x.dateop || '') <= this.datefin);
        if (this.filtreCaisse)
          data = data.filter(x => x.nomcaisse === this.filtreCaisse);
        return data;
      }
      // Fallback : données basiques de rapportdecaisse6 (déjà filtrées)
      return this.depenseJournalier;
    },

    // ── Catégories de dépense présentes (pour le select) ──────────────────────
    categoriesDepense() {
      return [...new Set(this.depensesBase.map(x => x.paramname || x.categorie || 'Autre'))].sort();
    },

    // ── Montant par catégorie (récap, toutes catégories, trié desc) ───────────
    depenseParCategorie() {
      const map = {};
      for (const d of this.depensesBase) {
        const cat = d.paramname || d.categorie || 'Autre';
        if (!map[cat]) map[cat] = { categorie: cat, nb: 0, montant: 0 };
        map[cat].nb += 1;
        map[cat].montant += parseFloat(d.montant || 0);
      }
      return Object.values(map).sort((a, b) => b.montant - a.montant);
    },

    // ── Dépenses enrichies (récap + filtre catégorie du select) ───────────────
    depenseEnrichie() {
      let data = this.depensesBase;
      if (this.filtreDepCategorie)
        data = data.filter(x => (x.paramname || x.categorie || 'Autre') === this.filtreDepCategorie);
      return data;
    },

    // ── Décomposition du bilan par caisse ────────────────────────────────────
    bilanDecomposition() {
      const ops    = this.ops;
      const caisses = this.vueCaisse ? [this.vueCaisse] : this.caissesDisponibles;

      const filterSum = (arr, nomcaisse, field = 'montant') => {
        if (!arr) return 0;
        return arr
          .filter(x => !nomcaisse || x.nomcaisse === nomcaisse || x.caisse === nomcaisse)
          .reduce((s, x) => s + parseFloat(x[field] || 0), 0);
      };

      const buildRow = (caisse) => {
        const ouverture = this.soldesOuverture
          .filter(x => !caisse || x.nomcaisse === caisse)
          .reduce((s, x) => s + parseFloat(x.montant || 0), 0);

        const ventes = (ops.CAparfactureparcollaborateur || [])
          .filter(x => !caisse || x.nomcaisse === caisse)
          .reduce((s, x) => s + parseFloat(x.montanttotal || 0), 0);

        // Vente non encaissée = reste dû sur les factures (docmtnttotalttctrt) ;
        // vente réellement encaissée = vente nette − reste dû.
        const venteNonEncaissee = (ops.CAparfactureparcollaborateur || [])
          .filter(x => !caisse || x.nomcaisse === caisse)
          .reduce((s, x) => s + parseFloat(x.montanttotalrestant || 0), 0);
        const venteEncaissee = ventes - venteNonEncaissee;

        const appro   = filterSum(ops.arrayAPPRO,            caisse, 'cmontant');
        const approc  = filterSum(ops.arrayAPPROC,           caisse, 'cmontant');
        const rglclt  = filterSum(ops.newarrayRGLTCLT,       caisse);
        const depots  = filterSum(ops.newarrayDEPOTCLIENT,   caisse);
        const retours = filterSum(ops.newarrayREF,            caisse);
        const depenses= filterSum(ops.newarraydepense,        caisse);
        const rglfrs  = filterSum(ops.newarrayRGLTFRS,        caisse);
        const bcdca   = filterSum(ops.newarrayBCDCA,          caisse);
        const solde   = ouverture + ventes + appro + approc + rglclt
                      + depots + retours - depenses - rglfrs - bcdca;

        return { caisse: caisse || 'GLOBAL', ouverture, ventes, venteNonEncaissee, venteEncaissee,
                 appro, approc, rglclt, depots, retours, depenses, rglfrs, bcdca, solde };
      };

      const rows = caisses.map(c => buildRow(c));

      if (rows.length > 1) {
        const tot = (key) => rows.reduce((s, r) => s + r[key], 0);
        rows.push({
          caisse: 'TOTAL', isTotal: true,
          ouverture: tot('ouverture'), ventes:   tot('ventes'),
          venteNonEncaissee: tot('venteNonEncaissee'), venteEncaissee: tot('venteEncaissee'),
          appro:     tot('appro'),     approc:   tot('approc'),
          rglclt:    tot('rglclt'),    depots:   tot('depots'),
          retours:   tot('retours'),   depenses: tot('depenses'),
          rglfrs:    tot('rglfrs'),    bcdca:    tot('bcdca'),
          solde:     this.soldeReel,
        });
      }
      return rows;
    },

    // ══════════════════════════════════════════════════════════════════════════
    // COMPUTED - DONNÉES EXISTANTES (inchangées)
    // ══════════════════════════════════════════════════════════════════════════

    // ── Ventes filtrées (tous les filtres) ───────────────────────────────────
    ventesFiltered() {
      let v = this.datatable.ventes || [];
      if (this.datedebut)           v = v.filter(x => x.date >= this.datedebut);
      if (this.datefin)             v = v.filter(x => x.date <= this.datefin);
      if (this.filtreCatalogue)     v = v.filter(x => x.catalogue === this.filtreCatalogue);
      if (this.filtreCollaborateur) v = v.filter(x => x.collaborateur === this.filtreCollaborateur);
      if (this.filtreArticle)       v = v.filter(x => x.article && x.article.toLowerCase().includes(this.filtreArticle.toLowerCase()));
      if (this.filtreCaisse)        v = v.filter(x => x.caisse === this.filtreCaisse);
      if (this.filtreMagasin)       v = v.filter(x => x.magasin === this.filtreMagasin);
      return v;
    },

    // ── Ventes filtrées par vueCaisse (pour onglets KPI/SYNTH/BILAN) ─────────
    ventesVue() {
      if (!this.vueCaisse) return this.ventesFiltered;
      return this.ventesFiltered.filter(x => x.caisse === this.vueCaisse);
    },

    // ── Dépenses filtrées ────────────────────────────────────────────────────
    depensesFiltered() {
      let d = this.datatable.depenses || [];
      if (this.datedebut)           d = d.filter(x => x.date >= this.datedebut);
      if (this.datefin)             d = d.filter(x => x.date <= this.datefin);
      if (this.filtreCollaborateur) d = d.filter(x => x.collaborateur === this.filtreCollaborateur);
      if (this.filtreCaisse)        d = d.filter(x => x.caisse === this.filtreCaisse);
      return d;
    },

    depensesVue() {
      if (!this.vueCaisse) return this.depensesFiltered;
      return this.depensesFiltered.filter(x => x.caisse === this.vueCaisse);
    },

    // ── Listes dropdowns ─────────────────────────────────────────────────────
    cataloguesDisponibles() {
      return [...new Set((this.datatable.ventes || []).map(v => v.catalogue).filter(Boolean))].sort();
    },
    collaborateursDisponibles() {
      return [...new Set((this.datatable.ventes || []).map(v => v.collaborateur).filter(Boolean))].sort();
    },
    caissesDisponibles() {
      // Inclut les caisses présentes dans les ventes ET dans les opérations
      const fromVentes = (this.datatable.ventes || []).map(v => v.caisse);
      const fromOps = [
        ...(this.ops.CAparfactureparcollaborateur || []).map(x => x.nomcaisse),
        ...(this.ops.newarraydepense || []).map(x => x.nomcaisse),
        ...(this.ops.arrayAPPRO || []).map(x => x.caisse),
        ...(this.ops.newarrayRGLTCLT || []).map(x => x.nomcaisse),
        ...(this.ops.newarrayRGLTFRS || []).map(x => x.nomcaisse),
      ];
      return [...new Set([...fromVentes, ...fromOps].filter(Boolean))].sort();
    },
    magasinsDisponibles() {
      return [...new Set((this.datatable.ventes || []).map(v => v.magasin).filter(Boolean))].sort();
    },
    creeleGroupe() {
      if (!this.groupeCreele || !['CAF', 'CADA'].includes(this.activeTab)) return [];
      const data = this.activeTabData;
      const dates = [...new Set(data.map(r => r.createdat_date || ''))].sort();
      return dates.map(date => {
        const lignes = data.filter(r => (r.createdat_date || '') === date);
        const totalMontant = lignes.reduce((s, r) => s + parseFloat(r.montant || 0), 0);
        return { groupe: date || '(sans date)', lignes, totalMontant };
      }).filter(g => g.lignes.length > 0);
    },

    // ── Filtres actifs ───────────────────────────────────────────────────────
    hasActiveFilters() {
      return !!(this.filtreCatalogue || this.filtreCollaborateur || this.filtreArticle || this.filtreCaisse || this.filtreMagasin);
    },
    activeFiltersCount() {
      return [this.filtreCatalogue, this.filtreCollaborateur, this.filtreArticle, this.filtreCaisse, this.filtreMagasin].filter(Boolean).length;
    },

    // ── KPI Globaux (sur toutes les ventes filtrées) ─────────────────────────
    kpiGlobal() {
      return this._computeKpi(this.ventesFiltered, this.depensesFiltered);
    },

    // ── KPI pour la vue courante (avec filtre caisse optionnel) ──────────────
    kpiCurrent() {
      return this._computeKpi(this.ventesVue, this.depensesVue);
    },

    kpiCards() {
      const k = this.kpiCurrent;
      const label = this.vueCaisse ? ` (${this.vueCaisse})` : '';
      return [
        { label: 'VENTES BRUTES'   + label, value: this.formatMoney(k.recetteBrute),  sub: 'Total avant remises',              color: '#ca8a04' },
        { label: 'CA APRÈS REMISES'+ label, value: this.formatMoney(k.caNet),         sub: 'Net après remises',                color: '#16a34a' },
        { label: 'NB FACTURES'     + label, value: String(k.nbFactures),              sub: 'Transactions enregistrées',        color: '#7c3aed' },
        { label: 'MARGE BRUTE'     + label, value: this.formatMoney(k.margeBrute),    sub: 'CA net − coût d\'achat',           color: '#2563eb' },
        { label: 'TOTAL DÉPENSES'  + label, value: this.formatMoney(k.totalDepenses), sub: `${this.depensesVue.length} opération(s)`, color: '#dc2626' },
      ];
    },

    // ── KPI par caisse ───────────────────────────────────────────────────────
    kpiParCaisse() {
      const totalGlobal = this.ventesFiltered.reduce((s, v) => s + parseFloat(v.montant || 0), 0);
      return this.caissesDisponibles.map(caisse => {
        const vCaisse = this.ventesFiltered.filter(v => v.caisse === caisse);
        const dCaisse = this.depensesFiltered.filter(d => d.caisse === caisse);
        const k = this._computeKpi(vCaisse, dCaisse);
        return {
          caisse,
          nbFactures: k.nbFactures,
          caBrut:     k.recetteBrute,
          remises:    k.totalRemises,
          caNet:      k.caNet,
          marge:      k.margeBrute,
          depenses:   k.totalDepenses,
          solde:      k.soldeNet,
          pct:        totalGlobal > 0 ? parseFloat(((k.recetteBrute / totalGlobal) * 100).toFixed(1)) : 0,
        };
      }).filter(r => r.caBrut > 0 || r.depenses > 0);
    },

    // ── Synthèse par catalogue (vue caisse optionnelle) ───────────────────────
    syntheseParCatalogueFiltered() {
      const ventes = this.ventesVue;
      const totalGlobal = ventes.reduce((s, v) => s + parseFloat(v.montant || 0), 0);
      return this.cataloguesDisponibles.map(cat => {
        const lignes = ventes.filter(v => v.catalogue === cat);
        if (!lignes.length) return null;
        const caBrut  = lignes.reduce((s, v) => s + parseFloat(v.montant || 0), 0);
        const remises = lignes.reduce((s, v) => s + parseFloat(v.remise  || 0), 0);
        const qte     = lignes.reduce((s, v) => s + parseFloat(v.qte    || 0), 0);
        const cout    = lignes.reduce((s, v) => s + parseFloat(v.pa || 0) * parseFloat(v.qte || 0), 0);
        const nbArticles = new Set(lignes.map(v => v.article)).size;
        const pct     = totalGlobal > 0 ? parseFloat(((caBrut / totalGlobal) * 100).toFixed(1)) : 0;
        return { catalogue: cat, nbArticles, nbLines: lignes.length, qte, caBrut, remises, caNet: caBrut - remises, marge: caBrut - remises - cout, pct };
      }).filter(Boolean);
    },

    // Alias pour compatibilité onglet SYNTH
    syntheseParCatalogue() { return this.syntheseParCatalogueFiltered; },

    // ── Bilan courant (avec vue caisse) ───────────────────────────────────────
    bilanCurrent() {
      const k = this.kpiCurrent;
      return { recetteBrute: k.recetteBrute, totalRemises: k.totalRemises, totalDepenses: k.totalDepenses, caNet: k.caNet, soldeNet: k.soldeNet };
    },

    // ── Bilan par caisse ─────────────────────────────────────────────────────
    bilanParCaisse() { return this.kpiParCaisse; },

    // ── Map facture → { total, restant, remise } (source documents) ───────────
    // Vérité monétaire : montanttotal = docmtnttotalttc (déjà net TTC),
    // montanttotalrestant = reste dû, mtntremise = remise document (signés BR).
    factureMap() {
      const map = {};
      for (const f of (this.ops.CAparfactureparcollaborateur || [])) {
        map[f.docref] = {
          total:   parseFloat(f.montanttotal        || 0),
          restant: parseFloat(f.montanttotalrestant || 0),
          remise:  parseFloat(f.mtntremise          || 0),
        };
      }
      return map;
    },

    // ── CA Journalier (source documents CAparfactureparcollaborateur) ─────────
    caJournalier() {
      let src = this.ops.CAparfactureparcollaborateur || [];
      if (this.datedebut)           src = src.filter(x => (x.dateop || '') >= this.datedebut);
      if (this.datefin)             src = src.filter(x => (x.dateop || '') <= this.datefin);
      if (this.filtreCaisse)        src = src.filter(x => x.nomcaisse === this.filtreCaisse);
      if (this.filtreCollaborateur) src = src.filter(x => x.collaborateur === this.filtreCollaborateur);

      const dates = [...new Set(src.map(v => v.dateop))].sort();
      return dates.map(date => {
        const l       = src.filter(v => v.dateop === date);
        const total   = l.reduce((s, v) => s + parseFloat(v.montanttotal        || 0), 0);
        const restant = l.reduce((s, v) => s + parseFloat(v.montanttotalrestant || 0), 0);
        const remises = l.reduce((s, v) => s + parseFloat(v.mtntremise          || 0), 0);
        return {
          date,
          nbFactures: new Set(l.map(v => v.docref)).size,
          montant:    total,
          remises,
          restant,
          encaisse:   total - restant,
        };
      });
    },

    // ── Factures filtrées date + caisse + collab (base NORM / MODEREG) ────────
    factsBase() {
      let src = this.ops.CAparfactureparcollaborateur || [];
      if (this.datedebut)           src = src.filter(x => (x.dateop || '') >= this.datedebut);
      if (this.datefin)             src = src.filter(x => (x.dateop || '') <= this.datefin);
      if (this.filtreCaisse)        src = src.filter(x => x.nomcaisse === this.filtreCaisse);
      if (this.filtreCollaborateur) src = src.filter(x => x.collaborateur === this.filtreCollaborateur);
      return src;
    },

    // ── NORM : point normalisées / non normalisées (récap global) ─────────────
    pointNormalisation() {
      const build = (label, pred) => {
        const l = this.factsBase.filter(pred);
        const montant = l.reduce((s, v) => s + parseFloat(v.montanttotal        || 0), 0);
        const restant = l.reduce((s, v) => s + parseFloat(v.montanttotalrestant || 0), 0);
        return { statut: label, nbFactures: l.length, montant, restant, encaisse: montant - restant };
      };
      return [
        build('Normalisées',     v => parseInt(v.normalise, 10) === 1),
        build('Non normalisées', v => parseInt(v.normalise, 10) !== 1),
      ];
    },

    // ── NORM : montant par date (respecte le sélecteur) ───────────────────────
    normParJour() {
      let src = this.factsBase;
      if (this.filtreNormalise === '1') src = src.filter(v => parseInt(v.normalise, 10) === 1);
      if (this.filtreNormalise === '0') src = src.filter(v => parseInt(v.normalise, 10) !== 1);
      const dates = [...new Set(src.map(v => v.dateop))].sort();
      return dates.map(date => {
        const l       = src.filter(v => v.dateop === date);
        const montant = l.reduce((s, v) => s + parseFloat(v.montanttotal        || 0), 0);
        const restant = l.reduce((s, v) => s + parseFloat(v.montanttotalrestant || 0), 0);
        return { date, nbFactures: l.length, montant, restant, encaisse: montant - restant };
      });
    },

    // ── MODEREG : modes présents (pour le select) ────────────────────────────
    modesReglement() {
      return [...new Set(this.factsBase.map(v => v.modereglement || 'Non précisé'))].sort();
    },

    // ── MODEREG : point par mode (récap global, encaissé desc) ────────────────
    pointModeReglement() {
      const map = {};
      for (const v of this.factsBase) {
        const mode = v.modereglement || 'Non précisé';
        if (!map[mode]) map[mode] = { mode, nbFactures: 0, montant: 0, restant: 0 };
        map[mode].nbFactures += 1;
        map[mode].montant    += parseFloat(v.montanttotal        || 0);
        map[mode].restant    += parseFloat(v.montanttotalrestant || 0);
      }
      return Object.values(map)
        .map(r => ({ ...r, encaisse: r.montant - r.restant }))
        .sort((a, b) => b.encaisse - a.encaisse);
    },

    // ── MODEREG : par (date × mode), respecte le sélecteur ────────────────────
    modeRegParJourMode() {
      let src = this.factsBase;
      if (this.filtreModeReg) src = src.filter(v => (v.modereglement || 'Non précisé') === this.filtreModeReg);
      const map = {};
      for (const v of src) {
        const mode = v.modereglement || 'Non précisé';
        const key  = v.dateop + '||' + mode;
        if (!map[key]) map[key] = { date: v.dateop, mode, nbFactures: 0, montant: 0, restant: 0 };
        map[key].nbFactures += 1;
        map[key].montant    += parseFloat(v.montanttotal        || 0);
        map[key].restant    += parseFloat(v.montanttotalrestant || 0);
      }
      return Object.values(map)
        .map(r => ({ ...r, encaisse: r.montant - r.restant }))
        .sort((a, b) => (a.date || '').localeCompare(b.date || '') || (a.mode || '').localeCompare(b.mode || ''));
    },

    // ── STOCK : lignes gérées en stock (instock=1), filtrées ─────────────────
    stockBase() {
      return this.ventesFiltered.filter(v => parseInt(v.instock, 10) === 1);
    },
    articlesStock() {
      return [...new Set(this.stockBase.map(v => v.article))].filter(Boolean).sort();
    },
    magasinsStock() {
      return [...new Set(this.stockBase.map(v => v.magasin))].filter(Boolean).sort();
    },

    // ── STOCK : suivi article × magasin × jour ────────────────────────────────
    // Snapshots capturés à la vente : initial = avantstock de la 1re ligne du jour,
    // final = apresstock de la dernière (ordre createat), total vente = Σ qte.
    suiviStock() {
      let src = this.stockBase;
      if (this.filtreStockArticle) src = src.filter(v => v.article === this.filtreStockArticle);
      if (this.filtreStockMagasin) src = src.filter(v => v.magasin === this.filtreStockMagasin);

      const groups = {};
      for (const v of src) {
        const key = (v.article || '') + '||' + (v.magasin || '') + '||' + (v.date || '');
        (groups[key] = groups[key] || []).push(v);
      }
      return Object.values(groups).map(lignes => {
        const l = [...lignes].sort((a, b) => (a.createat || '').localeCompare(b.createat || ''));
        const stockInitial = parseFloat(l[0].qtstck_avant || 0);
        const stockFinal   = parseFloat(l[l.length - 1].qtstck_apres || 0);
        const totalVente   = l.reduce((s, v) => s + parseFloat(v.qte || 0), 0);
        return {
          article:      l[0].article || '',
          magasin:      l[0].magasin || '',
          date:         l[0].date    || '',
          stockInitial,
          totalVente,
          stockFinal,
          variation:    stockInitial - stockFinal,
        };
      }).sort((a, b) => (a.article || '').localeCompare(b.article || '')
                     || (a.magasin || '').localeCompare(b.magasin || '')
                     || (a.date    || '').localeCompare(b.date    || ''));
    },

    // ── CA Global par article (CAGA) ──────────────────────────────────────────
    caGlobalParArticle() {
      return [...new Set(this.ventesFiltered.map(v => v.article))].sort().map(article => {
        const lignes  = this.ventesFiltered.filter(v => v.article === article);
        const qte     = lignes.reduce((s, v) => s + parseFloat(v.qte    || 0), 0);
        const montant = lignes.reduce((s, v) => s + parseFloat(v.montant || 0), 0);
        const remise  = lignes.reduce((s, v) => s + parseFloat(v.remise  || 0), 0);
        const cout    = lignes.reduce((s, v) => s + parseFloat(v.pa || 0) * parseFloat(v.qte || 0), 0);
        return {
          article,
          catalogue:   lignes[0]?.catalogue || '',
          caisse:      lignes[0]?.caisse     || '',
          magasin:     lignes[0]?.magasin    || '',
          qte,
          puMoyen:     qte > 0 ? montant / qte : 0,
          montant,
          remise,
          marge:       montant - remise - cout,
        };
      });
    },

    // ── CAGA groupé (par magasin / caisse / catalogue) ────────────────────────
    caGlobalGroupe() {
      if (!this.groupeCaga) return [];
      const field = this.groupeCaga; // 'magasin' | 'caisse' | 'catalogue'
      const groupes = [...new Set(this.ventesFiltered.map(v => v[field] || 'N/A'))].sort();
      return groupes.map(groupe => {
        const lignesVentes = this.ventesFiltered.filter(v => (v[field] || 'N/A') === groupe);
        const articles = [...new Set(lignesVentes.map(v => v.article))].sort().map(article => {
          const lignes  = lignesVentes.filter(v => v.article === article);
          const qte     = lignes.reduce((s, v) => s + parseFloat(v.qte    || 0), 0);
          const montant = lignes.reduce((s, v) => s + parseFloat(v.montant || 0), 0);
          const remise  = lignes.reduce((s, v) => s + parseFloat(v.remise  || 0), 0);
          const cout    = lignes.reduce((s, v) => s + parseFloat(v.pa || 0) * parseFloat(v.qte || 0), 0);
          return { article, catalogue: lignes[0]?.catalogue || '', caisse: lignes[0]?.caisse || '', magasin: lignes[0]?.magasin || '', qte, puMoyen: qte > 0 ? montant / qte : 0, montant, remise, marge: montant - remise - cout };
        });
        const totalMontant = articles.reduce((s, a) => s + a.montant, 0);
        return { groupe, lignes: articles, totalMontant };
      }).filter(g => g.lignes.length > 0);
    },

    // ── CA Détaillé (CADA) ────────────────────────────────────────────────────
    caDetailleParArticle() {
      return this.ventesFiltered.map(v => {
        // Champ backend = 'createat' (sans 'd') - voir SQL rapportdecaisse6
        const cd = parseCreatedAt(v.createat);
        const stockDiff = parseFloat(v.qtstck_apres || 0) - parseFloat(v.qtstck_avant || 0);
        return {
          typeDocument:      v.doctyp === 'BR' ? 'Avoir (BR)' : 'Vente (F)',
          doctyp:            v.doctyp || 'F',
          createdat_display: v.createat,
          createdat_date:    cd.createdat_date,
          createdat_time:    cd.createdat_time,
          date:              v.date,
          heure:             v.heure,
          numfacture:        v.numfacture,
          collaborateur:     v.collaborateur,
          caisse:            v.caisse        || '',
          magasin:           v.magasin       || '',
          catalogue:         v.catalogue,
          article:           v.article,
          qte:               parseFloat(v.qte     || 0),
          pu:                parseFloat(v.pu      || 0),
          remise:            parseFloat(v.remise  || 0),
          montant:           parseFloat(v.montant || 0),
          marge:             parseFloat(v.montant || 0) - parseFloat(v.remise || 0) - parseFloat(v.pa || 0) * parseFloat(v.qte || 0),
          qtstck_avant:      parseFloat(v.qtstck_avant || 0),
          oldquantite:       v.oldquantite !== null && v.oldquantite !== undefined ? parseFloat(v.oldquantite) : null,
          qtstck_apres:      parseFloat(v.qtstck_apres || 0),
          stockDiff,
        };
      });
    },

    // ── CA par facture (CAF) ──────────────────────────────────────────────────
    // Colonnes descriptives = source lignes ; argent = factureMap (doc, correct).
    caParFacture() {
      const src = this.ventesFiltered;
      const fm  = this.factureMap;
      return [...new Set(src.map(v => v.numfacture))].map(fac => {
        const lignes  = src.filter(v => v.numfacture === fac);
        const doc     = fm[fac] || { total: 0, restant: 0, remise: 0 };
        const montant = doc.total;
        const remise  = doc.remise;
        const restant = doc.restant;
        // Champ backend = 'createat' (sans 'd') - voir SQL rapportdecaisse6
        const cd      = parseCreatedAt(lignes[0]?.createat);
        const doctyp  = lignes[0]?.doctyp || 'F';
        return {
          typeDocument:      doctyp === 'BR' ? 'Avoir (BR)' : 'Vente (F)',
          doctyp,
          numfacture:        fac,
          createdat_display: lignes[0]?.createat,
          createdat_date:    cd.createdat_date,
          createdat_time:    cd.createdat_time,
          date:              lignes[0]?.date          || '',
          heure:             lignes[0]?.heure         || '',
          collaborateur:     lignes[0]?.collaborateur || '',
          caisse:            lignes[0]?.caisse        || '',
          magasin:           lignes[0]?.magasin       || '',
          catalogue:         [...new Set(lignes.map(v => v.catalogue))].join(', '),
          nbLignes:          lignes.length,
          montant,
          remise,
          restant,
          encaisse:          montant - restant,
        };
      }).sort((a, b) => a.date.localeCompare(b.date) || a.heure.localeCompare(b.heure));
    },

    // ── KPI Factures / Avoirs (CAF + CADA) ───────────────────────────────────
    kpiFactures() {
      const ventes = this.ventesFiltered;
      // Factures normales (F) - montants positifs
      const lignesF  = ventes.filter(v => v.doctyp === 'F');
      const lignesBR = ventes.filter(v => v.doctyp === 'BR');
      const montantF  = lignesF.reduce((s, v)  => s + parseFloat(v.montant || 0), 0);
      // montantBR est déjà négatif dans les données (signe appliqué côté backend)
      const montantBR = lignesBR.reduce((s, v) => s + parseFloat(v.montant || 0), 0);
      return {
        montantF,
        montantBR_affiche: Math.abs(montantBR),         // affiché en positif
        caNet:             montantF + montantBR,         // F + (BR négatif) = F − |BR|
        nbF:    new Set(lignesF.map(v  => v.numfacture)).size,
        nbBR:   new Set(lignesBR.map(v => v.numfacture)).size,
        remise: ventes.reduce((s, v) => s + Math.abs(parseFloat(v.remise || 0)), 0),
      };
    },

    // ── CA par facture / collaborateur (CAFC) ────────────────────────────────
    caParFactureParCollaborateur() {
      const fm = this.factureMap;
      return [...new Set(this.ventesFiltered.map(v => v.collaborateur))].sort().map(collab => {
        const lignes   = this.ventesFiltered.filter(v => v.collaborateur === collab);
        const factures = [...new Set(lignes.map(v => v.numfacture))];
        let montant = 0, remise = 0, restant = 0;
        for (const fac of factures) {
          const doc = fm[fac] || { total: 0, restant: 0, remise: 0 };
          montant += doc.total;
          remise  += doc.remise;
          restant += doc.restant;
        }
        return {
          collaborateur: collab,
          nbFactures:    factures.length,
          montant,
          remise,
          restant,
          encaisse:      montant - restant,
        };
      });
    },

    // ── Dépenses journalier (DEP) ─────────────────────────────────────────────
    depenseJournalier() {
      return this.depensesFiltered.map((d, i) => {
        const cd = parseCreatedAt(d.createdat);
        return {
          num:               i + 1,
          date:              d.date,
          heure:             d.heure,
          libelle:           d.libelle,
          categorie:         d.categorie,
          caisse:            d.caisse || '',
          montant:           parseFloat(d.montant || 0),
          collaborateur:     d.collaborateur,
          createdat_display: d.createdat,
          createdat_date:    cd.createdat_date,
          createdat_time:    cd.createdat_time,
        };
      });
    },

    // ── Métadonnées onglet actif ──────────────────────────────────────────────
    activeTabLabel() {
      return (this.tabs.find(t => t.id === this.activeTab) || {}).label || '';
    },
    activeTabHasTable() {
      return !['KPI', 'REPARTITION', 'BILAN'].includes(this.activeTab);
    },
    activeTabData() {
      switch (this.activeTab) {
        case 'SYNTH':  return this.syntheseParCatalogue;
        case 'CAJ':    return this.caJournalier;
        case 'CAGA':   return this.caGlobalParArticle;
        case 'CADA':   return this.caDetailleParArticle;
        case 'CAF':    return this.caParFacture;
        case 'CAFC':   return this.caParFactureParCollaborateur;
        case 'OPC':    return this.opcData;
        case 'RGLCLT': return this.rglcltData;
        case 'RGLFRS': return this.rglfrsData;
        case 'DEP':    return this.depenseEnrichie;
        case 'NORM':   return this.normParJour;
        case 'MODEREG':return this.modeRegParJourMode;
        case 'STOCK':  return this.suiviStock;
        default:       return [];
      }
    },
    activeTabColumns() {
      return this.tabColumns[this.activeTab] || [];
    },
    activeTabTotals() {
      const data = this.activeTabData;
      const totals = {};
      this.activeTabColumns.forEach(col => {
        if (col.type === 'money' || col.type === 'number') {
          totals[col.key] = data.reduce((s, row) => s + (parseFloat(row[col.key]) || 0), 0);
        }
      });
      return totals;
    },
    activeTabSummary() {
      const d  = this.activeTabData;
      const v  = this.ventesFiltered;
      const nb = new Set(v.map(x => x.numfacture)).size;
      const vueSuffix = this.vueCaisse ? ` · ${this.vueCaisse}` : '';
      const map = {
        KPI:         `${v.length} ligne(s) · ${nb} facture(s)${vueSuffix}`,
        SYNTH:       `${d.length} catalogue(s)${vueSuffix}`,
        REPARTITION: `${this.syntheseParCatalogueFiltered.length} catalogue(s) · CA : ${this.formatMoney(this.kpiCurrent.recetteBrute)}${vueSuffix}`,
        CAJ:         `${d.length} jour(s)`,
        CAGA:        this.groupeCaga ? `Groupé par ${this.groupeCaga} · ${this.caGlobalGroupe.length} groupe(s)` : `${d.length} article(s)`,
        CADA:        this.groupeCreele ? `Groupé par créé le · ${this.creeleGroupe.length} date(s)` : `${d.length} ligne(s) de vente`,
        CAF:         this.groupeCreele ? `Groupé par créé le · ${this.creeleGroupe.length} date(s)` : `${d.length} facture(s)`,
        CAFC:        `${d.length} collaborateur(s)`,
        OPC:         `${d.length} opération(s)`,
        RGLCLT:      `${d.length} règlement(s) · ${this.formatMoney((this.ops.newarrayRGLTCLT||[]).reduce((s,x)=>s+parseFloat(x.montant||0),0))}`,
        RGLFRS:      `${d.length} règlement(s) · ${this.formatMoney(this.rglfrsData.reduce((s,x)=>s+parseFloat(x.montant||0),0))}`,
        DEP:         `${d.length} dépense(s) · ${this.formatMoney(d.reduce((s,x)=>s+parseFloat(x.montant||0),0))}`,
        NORM:        `${d.length} jour(s) · ${this.factsBase.length} facture(s)`,
        MODEREG:     `${this.modesReglement.length} mode(s) · ${this.formatMoney(this.pointModeReglement.reduce((s,x)=>s+x.encaisse,0))} encaissé`,
        STOCK:       `${this.articlesStock.length} article(s) en stock · ${d.length} ligne(s)`,
        BILAN:       `Solde théorique : ${this.formatMoney(this.soldeReel)}${vueSuffix}`,
      };
      return map[this.activeTab] || '';
    },

    // ── Pagination ────────────────────────────────────────────────────────────
    totalPages() {
      return Math.max(1, Math.ceil(this.activeTabData.length / this.itemsPerPage));
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.activeTabData.slice(start, start + this.itemsPerPage);
    },
  },

  data() {
    return {
      useMockData: false,

      isdisplay:    false,
      titlemodal:   '',
      datedebut:    currentDate(),
      datefin:      currentDate(),
      numpidcaisse: '',
      typedoc:      '',

      currentPage:  1,
      itemsPerPage: 20,
      activeTab:    'KPI',

      showAdvancedFilters:  false,
      filtreCatalogue:      '',
      filtreCollaborateur:  '',
      filtreArticle:        '',
      filtreCaisse:         '',
      filtreMagasin:        '',

      // Vue par caisse (KPI / SYNTH / REPARTITION / BILAN)
      vueCaisse: '',

      // Groupement CAGA
      groupeCaga: '',

      // Groupement créé le (CAF / CADA)
      groupeCreele: '',

      // Filtre catégorie (DEP)
      filtreDepCategorie: '',

      // Filtre normalisation (NORM) et mode de règlement (MODEREG)
      filtreNormalise: '',
      filtreModeReg:   '',

      // Filtres suivi de stock (STOCK)
      filtreStockArticle: '',
      filtreStockMagasin: '',

      datatable: { ventes: [], depenses: [], ops: {} },

      tabs: [
        { id: 'KPI',         label: 'KPI GLOBAUX'             },
        { id: 'SYNTH',       label: 'SYNTHÈSE / CATALOGUE'    },
        { id: 'REPARTITION', label: 'RÉPARTITION CA'          },
        { id: 'CAJ',         label: 'CA JOURNALIER'           },
        { id: 'CAGA',        label: 'CA GLOBAL (ARTICLE)'     },
        { id: 'CADA',        label: 'CA DÉTAILLÉ (ARTICLE)'   },
        { id: 'CAF',         label: 'CA PAR FACTURE'          },
        { id: 'CAFC',        label: 'CA FACTURE / COLLAB'     },
        { id: 'OPC',         label: 'OPÉRATIONS CAISSE'       },
        { id: 'RGLCLT',      label: 'RÈGLEMENTS CLIENTS'      },
        { id: 'RGLFRS',      label: 'RÈGLEMENTS FOURNISSEURS' },
        { id: 'DEP',         label: 'DÉPENSES'                },
        { id: 'NORM',        label: 'NORMALISATION'          },
        { id: 'MODEREG',     label: 'MODE DE RÈGLEMENT'      },
        { id: 'STOCK',       label: 'SUIVI DE STOCK'         },
        { id: 'BILAN',       label: 'BILAN FINAL'             },
      ],

      tabColumns: {
        SYNTH: [
          { key: 'catalogue',  label: 'CATALOGUE',    align: 'left' },
          { key: 'nbArticles', label: 'NB ART.',       type: 'number' },
          { key: 'qte',        label: 'QTÉ',           type: 'number' },
          { key: 'caBrut',     label: 'CA BRUT',       type: 'money'  },
          { key: 'remises',    label: 'REMISES',        type: 'money'  },
          { key: 'caNet',      label: 'CA NET',         type: 'money'  },
          { key: 'marge',      label: 'MARGE',          type: 'money'  },
          { key: 'pct',        label: '% CA',           type: 'percent'},
        ],
        CAJ: [
          { key: 'date',       label: 'DATE',            align: 'left' },
          { key: 'nbFactures', label: 'NB FACTURES',     type: 'number' },
          { key: 'montant',    label: 'MONTANT TOTAL',   type: 'money'  },
          { key: 'remises',    label: 'REMISES',         type: 'money'  },
          { key: 'restant',    label: 'MONTANT RESTANT', type: 'money'  },
          { key: 'encaisse',   label: 'ENCAISSÉ',        type: 'money'  },
        ],
        CAGA: [
          { key: 'article',    label: 'ARTICLE',        align: 'left' },
          { key: 'catalogue',  label: 'CATALOGUE'                     },
          { key: 'caisse',     label: 'CAISSE'                        },
          { key: 'magasin',    label: 'MAGASIN'                       },
          { key: 'qte',        label: 'QTÉ',            type: 'number' },
          { key: 'puMoyen',    label: 'PU MOY',         type: 'money'  },
          { key: 'montant',    label: 'MONTANT',         type: 'money'  },
          { key: 'remise',     label: 'REMISE',          type: 'money'  },
          { key: 'marge',      label: 'MARGE',           type: 'money'  },
        ],
        CADA: [
          { key: 'typeDocument',      label: 'TYPE',          align: 'left' },
          { key: 'createdat_display', label: 'CRÉÉ LE'                 },
          { key: 'date',              label: 'DATE DOC'               },
          { key: 'heure',             label: 'HEURE'                  },
          { key: 'numfacture',        label: 'FACTURE'                },
          { key: 'collaborateur',     label: 'COLLABORATEUR', align: 'left' },
          { key: 'caisse',            label: 'CAISSE'                 },
          { key: 'magasin',           label: 'MAGASIN'                },
          { key: 'catalogue',         label: 'CATALOGUE'              },
          { key: 'article',           label: 'ARTICLE',       align: 'left' },
          { key: 'qte',               label: 'QTÉ',           type: 'number' },
          { key: 'pu',                label: 'PU',             type: 'money'  },
          { key: 'remise',            label: 'REMISE',         type: 'money'  },
          { key: 'montant',           label: 'MONTANT',        type: 'money'  },
          { key: 'marge',             label: 'MARGE',          type: 'money'  },
          { key: 'qtstck_avant',      label: 'STK AVANT',     type: 'number' },
          { key: 'oldquantite',       label: 'ANC. QTÉ',      type: 'number' },
          { key: 'stockDiff',         label: 'VARIATION',     type: 'number' },
          { key: 'qtstck_apres',      label: 'STK FINAL',     type: 'number' },
        ],
        CAF: [
          { key: 'typeDocument',      label: 'TYPE',          align: 'left' },
          { key: 'numfacture',        label: 'N° FACTURE'             },
          { key: 'createdat_display', label: 'CRÉÉ LE'                },
          { key: 'date',              label: 'DATE'                   },
          { key: 'heure',             label: 'HEURE'                  },
          { key: 'collaborateur',     label: 'COLLABORATEUR', align: 'left' },
          { key: 'caisse',            label: 'CAISSE'                 },
          { key: 'magasin',           label: 'MAGASIN'                },
          { key: 'catalogue',         label: 'CATALOGUE(S)',  align: 'left' },
          { key: 'nbLignes',          label: 'NB LIGNES',     type: 'number' },
          { key: 'montant',           label: 'MONTANT TOTAL',   type: 'money'  },
          { key: 'remise',            label: 'REMISE',          type: 'money'  },
          { key: 'restant',           label: 'MONTANT RESTANT', type: 'money'  },
          { key: 'encaisse',          label: 'ENCAISSÉ',        type: 'money'  },
        ],
        CAFC: [
          { key: 'collaborateur', label: 'COLLABORATEUR',   align: 'left' },
          { key: 'nbFactures',    label: 'NB FACTURES',     type: 'number' },
          { key: 'montant',       label: 'MONTANT TOTAL',   type: 'money'  },
          { key: 'remise',        label: 'REMISE',          type: 'money'  },
          { key: 'restant',       label: 'MONTANT RESTANT', type: 'money'  },
          { key: 'encaisse',      label: 'ENCAISSÉ',        type: 'money'  },
        ],
        OPC: [
          { key: 'typeoperation',    label: 'TYPE',             align: 'left' },
          { key: 'dateop',           label: 'DATE'                           },
          { key: 'numdoc',           label: 'N° DOC'                         },
          { key: 'nomcaisse',        label: 'CAISSE'                         },
          { key: 'caissedebiteur',   label: 'CAISSE DÉBITEUR', align: 'left' },
          { key: 'caissecrediteur',  label: 'CAISSE CRÉDITEUR',align: 'left' },
          { key: 'banque',           label: 'BANQUE',           align: 'left' },
          { key: 'beneficiaire',     label: 'BÉNÉFICIAIRE',     align: 'left' },
          { key: 'motif',            label: 'MOTIF',            align: 'left' },
          { key: 'montant',          label: 'MONTANT',          type: 'money' },
        ],
        RGLCLT: [
          { key: 'typeoperation',    label: 'TYPE',             align: 'left' },
          { key: 'dateop',           label: 'DATE'                           },
          { key: 'numdoc',           label: 'N° DOC'                         },
          { key: 'nomcaisse',        label: 'CAISSE'                         },
          { key: 'beneficiaire',     label: 'CLIENT / BÉNÉF.', align: 'left' },
          { key: 'montant',          label: 'MONTANT',          type: 'money' },
        ],
        RGLFRS: [
          { key: 'typeoperation',    label: 'TYPE',             align: 'left' },
          { key: 'dateop',           label: 'DATE'                           },
          { key: 'numdoc',           label: 'N° DOC'                         },
          { key: 'nomcaisse',        label: 'CAISSE'                         },
          { key: 'beneficiaire',     label: 'FOURN. / BÉNÉF.', align: 'left' },
          { key: 'montant',          label: 'MONTANT',          type: 'money' },
        ],
        DEP: [
          { key: 'dateop',           label: 'DATE'                           },
          { key: 'numdoc',           label: 'N° DOC'                         },
          { key: 'nomcaisse',        label: 'CAISSE'                         },
          { key: 'beneficiaire',     label: 'BÉNÉFICIAIRE',     align: 'left' },
          { key: 'paramname',        label: 'CATÉGORIE'                      },
          { key: 'motif',            label: 'MOTIF',            align: 'left' },
          { key: 'saisir_par',       label: 'SAISI PAR'                      },
          { key: 'creer_le',         label: 'CRÉÉ LE'                        },
          { key: 'montant',          label: 'MONTANT',          type: 'money' },
        ],
        NORM: [
          { key: 'date',       label: 'DATE',            align: 'left' },
          { key: 'nbFactures', label: 'NB FACTURES',     type: 'number' },
          { key: 'montant',    label: 'MONTANT TOTAL',   type: 'money'  },
          { key: 'restant',    label: 'MONTANT RESTANT', type: 'money'  },
          { key: 'encaisse',   label: 'ENCAISSÉ',        type: 'money'  },
        ],
        MODEREG: [
          { key: 'date',       label: 'DATE',            align: 'left' },
          { key: 'mode',       label: 'MODE',            align: 'left' },
          { key: 'nbFactures', label: 'NB FACTURES',     type: 'number' },
          { key: 'montant',    label: 'MONTANT TOTAL',   type: 'money'  },
          { key: 'restant',    label: 'MONTANT RESTANT', type: 'money'  },
          { key: 'encaisse',   label: 'ENCAISSÉ',        type: 'money'  },
        ],
        STOCK: [
          { key: 'article',      label: 'ARTICLE',       align: 'left' },
          { key: 'magasin',      label: 'MAGASIN',       align: 'left' },
          { key: 'date',         label: 'DATE',          align: 'left' },
          { key: 'stockInitial', label: 'STOCK INITIAL', type: 'number' },
          { key: 'totalVente',   label: 'TOTAL VENTE',   type: 'number' },
          { key: 'stockFinal',   label: 'STOCK FINAL',   type: 'number' },
          { key: 'variation',    label: 'VARIATION',     type: 'number' },
        ],
      },
    };
  },

  methods: {

    // ── Helper KPI ────────────────────────────────────────────────────────────
    _computeKpi(ventes, depenses) {
      const recetteBrute  = ventes.reduce((s, x) => s + parseFloat(x.montant || 0), 0);
      const totalRemises  = ventes.reduce((s, x) => s + parseFloat(x.remise  || 0), 0);
      const totalDepenses = depenses.reduce((s, x) => s + parseFloat(x.montant || 0), 0);
      const nbFactures    = new Set(ventes.map(x => x.numfacture)).size;
      const caNet         = recetteBrute - totalRemises;
      const cout          = ventes.reduce((s, x) => s + parseFloat(x.pa || 0) * parseFloat(x.qte || 0), 0);
      const margeBrute    = caNet - cout;
      const tauxRemise    = recetteBrute > 0 ? parseFloat(((totalRemises / recetteBrute) * 100).toFixed(1)) : 0;
      const panierMoyen   = nbFactures > 0 ? caNet / nbFactures : 0;
      const soldeNet      = caNet - totalDepenses;
      return { recetteBrute, totalRemises, totalDepenses, nbFactures, caNet, margeBrute, tauxRemise, panierMoyen, soldeNet };
    },

    // ── Ouverture ─────────────────────────────────────────────────────────────
    async show(titlemodal, numpidcaisse, datedouverture, typedoc) {
      this.titlemodal   = titlemodal;
      this.numpidcaisse = numpidcaisse;
      this.typedoc      = typedoc || '';
      this.activeTab    = 'KPI';
      this.currentPage  = 1;
      this.vueCaisse    = '';
      this.groupeCaga   = '';
      this.groupeCreele = '';
      this.datedebut    = datedouverture || currentDate();
      this.datefin      = datedouverture || currentDate();
      this.isdisplay    = true;
      await this.refresh();
    },

    // ── Fermeture ─────────────────────────────────────────────────────────────
    close() {
      this.isdisplay = false;
      this.$emit('closed');
    },

    // ── Réinitialiser ─────────────────────────────────────────────────────────
    resetFiltres() {
      this.filtreCatalogue     = '';
      this.filtreCollaborateur = '';
      this.filtreArticle       = '';
      this.filtreCaisse        = '';
      this.filtreMagasin       = '';
      this.vueCaisse           = '';
      this.groupeCaga          = '';
      this.groupeCreele        = '';
    },

    // ── Chargement données ────────────────────────────────────────────────────
    async refresh() {
      if (!isValidDateString(this.datedebut) || !isValidDateString(this.datefin)) return;

      this.$store.dispatch('lancerchargement', true);

      // ── Nouveau endpoint V2 (RapportCaissePeriodeController) ───────────────
      const url = `${process.env.VUE_APP_API_URL}/caisse/c/rapportperiode`
        + `/${this.datedebut}/${this.datefin}/${this.numpidcaisse}`
        + `/${this.$store.state.appsociete}/rapportcaisse6v2/${randomString()}`;

      try {
        const res = await axios.get(url, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept'          : 'application/json',
            'Content-Type'    : 'application/json',
            'Authorization'   : 'Bearer ' + JwtService.getToken(),
            'csrftoken'       : this.$store.state.appsociete,
          },
          withCredentials: true,
        });

        if (res.data.success) {
          this.datatable = {
            ventes  : res.data.m.ventes    || [],
            depenses: res.data.m.depenses  || [],
            ops     : res.data.m.operations || {},
          };

           this.$store.dispatch('lancerchargement', false);
        } else {
          this.datatable = { ventes: [], depenses: [], ops: {} };

           this.$store.dispatch('lancerchargement', false);
        }
      } catch (e) {
        this.datatable = { ventes: [], depenses: [], ops: {} };
         this.$store.dispatch('lancerchargement', false);
      } finally {
       
      }
    },

    // ── Export Excel ──────────────────────────────────────────────────────────
    exportCurrentTab() {
      const el = this.$refs.activetable;
      if (!el) return;
      ExportExcel('xlsx', `${this.activeTab}_${this.datedebut}_${this.datefin}_${currentDateTime()}`, null, null, el);
    },

    // ── Impression ────────────────────────────────────────────────────────────
    /* Gabarit « rapport-pro » : feuille autonome (sans Tailwind ni CDN), en-tête
       standard, TOUTES les lignes (pas seulement la page affichée), paysage
       automatique pour les tableaux larges. Les commandes d'écran (boutons,
       listes, pagination) sont retirées de la copie imprimée. */
    async printCurrentTab() {
      if (!this.$refs.printarea) return;

      const pageAvant = this.currentPage, parPageAvant = this.itemsPerPage;
      this.currentPage = 1;
      this.itemsPerPage = 999999;
      await this.$nextTick();
      const copie = this.$refs.printarea.cloneNode(true);
      this.itemsPerPage = parPageAvant;
      this.currentPage = pageAvant;

      copie.querySelectorAll('button, select, input, .pbi-no-print').forEach(n => n.remove());

      const jour = (d) => { const p = String(d || '').split('-'); return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : (d || ''); };
      const periode = this.datedebut === this.datefin
          ? 'Journée du ' + jour(this.datedebut)
          : 'Du ' + jour(this.datedebut) + ' au ' + jour(this.datefin);
      const normalise = { '1': 'Normalisées', '0': 'Non normalisées' };
      const filtres = [
        this.filtreCatalogue     && 'Catalogue : ' + this.filtreCatalogue,
        this.filtreCollaborateur && 'Collaborateur : ' + this.filtreCollaborateur,
        this.filtreArticle       && 'Article : ' + this.filtreArticle,
        this.filtreMagasin       && 'Magasin : ' + this.filtreMagasin,
        this.activeTab === 'CAGA' && this.groupeCaga && 'Groupé par : ' + this.groupeCaga,
        ['CAF', 'CADA'].includes(this.activeTab) && this.groupeCreele && 'Groupé par date de création',
        this.activeTab === 'DEP' && this.filtreDepCategorie && 'Catégorie : ' + this.filtreDepCategorie,
        this.activeTab === 'NORM' && this.filtreNormalise !== '' && (normalise[this.filtreNormalise] || this.filtreNormalise),
        this.activeTab === 'MODEREG' && this.filtreModeReg && 'Mode : ' + this.filtreModeReg,
        this.activeTab === 'STOCK' && this.filtreStockArticle && 'Article : ' + this.filtreStockArticle,
        this.activeTab === 'STOCK' && this.filtreStockMagasin && 'Magasin : ' + this.filtreStockMagasin,
      ];

      const st = this.$store.state;
      const entete = enteteRapport({
        logo: st.etatlogo, societe: st.etatraisonsocial, ifu: st.etatifu, rccm: st.etatrccm,
        telephone: st.etattelephone, adresse: st.etatadresse,
        titre: this.titlemodal, sousTitre: this.activeTabLabel, periode,
        caisse: this.vueCaisse || this.filtreCaisse || 'Toutes les caisses',
        imprimePar: st.appusername, filtres,
      });

      const orientation = (this.activeTab === 'BILAN' || this.activeTabColumns.length > 7) ? 'landscape' : 'portrait';
      const ok = imprimerRapport({ titre: `${this.titlemodal} - ${this.activeTabLabel}`, html: entete + copie.innerHTML, orientation });
      if (!ok) toastr['warning']("Le navigateur a bloqué la fenêtre d'impression : autorisez les fenêtres pop-up pour ce site.", '<b></b>');
    },

    // ── Couleurs ──────────────────────────────────────────────────────────────
    getCatalogueColor(cat) {
      const map = { Boissons:'#ca8a04', Restauration:'#16a34a', Snacks:'#2563eb', Tabac:'#7c3aed', Divers:'#6b7280' };
      return map[cat] || '#94a3b8';
    },
    getCaisseColor(caisse) {
      const palette = ['#2563eb','#16a34a','#dc2626','#7c3aed','#ca8a04','#0891b2','#be185d','#0f766e'];
      const idx = this.caissesDisponibles.indexOf(caisse);
      return palette[idx % palette.length] || '#94a3b8';
    },

    // ── Formatage créé le ─────────────────────────────────────────────────────
    fmtCreatedDate(row) {
      if (row.createdat_date) return row.createdat_date;
      const raw = row.createdat_display || '';
      if (!raw) return '-';
      const m = String(raw).match(/^(\d{4}-\d{2}-\d{2})/);
      return m ? m[1] : raw;
    },
    fmtCreatedTime(row) {
      if (row.createdat_time) return row.createdat_time;
      const raw = row.createdat_display || '';
      const m = String(raw).match(/[T ](\d{2}:\d{2})/);
      return m ? m[1] : '';
    },

    // ── Formatage ─────────────────────────────────────────────────────────────
    formatMoney(v)  { return currencyFormatDE(v); },
    formatNumber(v) { return FormatNumber(v); },
  },

  mounted() {},
};
</script>

<style scoped>
/* ── Modal (charte cf-/ds- : enveloppe renommée, dimensionnement Power BI conservé) ── */
.cf-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0 1rem;
  overflow: auto;
  background: rgb(15 23 42 / 0.45);
}
.cf-pbi-box {
  max-width: 92% !important;
  width: 100%;
  max-height: calc(100vh - 3.5rem);
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
}
.cf-pbi-content {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  width: 100% !important;
  height: 100vh!important;
}
.cf-pbi-head { display: flex; align-items: center; justify-content: space-between; }
.cf-pbi-body {
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 auto;
  min-height: 0;
}
.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity: 0; }

/* ── Transitions filtres avancés ────────────────────────────────── */
.expand-enter-active, .expand-leave-active { transition: all 0.25s ease; overflow: hidden; }
.expand-enter-from, .expand-leave-to { max-height: 0; opacity: 0; }
.expand-enter-to, .expand-leave-from { max-height: 300px; opacity: 1; }

/* ── Responsive modal ───────────────────────────────────────────── */
@media (max-width: 768px) {
  .cf-pbi-box { max-width: 100%; margin: 0; max-height: 100vh; border-radius: 0; }
}

/* ══════════════════════════════════════════════════
   POWER BI DESIGN SYSTEM
══════════════════════════════════════════════════ */

/* ── Header ─────────────────────────────────────── */
.pbi-header {
  background: white;
  border-bottom: 1px solid #e5e7eb;
  padding: 12px 16px;
}
:is(.dark) .pbi-header {
  background: #0f1117;
  border-bottom-color: rgba(255,255,255,0.06);
}
.pbi-header-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(37,99,235,0.35);
}
.pbi-close-btn {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.15s;
}
.pbi-close-btn:hover { color: #374151; background: #f3f4f6; }
:is(.dark) .pbi-close-btn:hover { color: #e5e7eb; background: rgba(255,255,255,0.06); }
.pbi-live-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(37,99,235,0.08);
  color: #2563eb;
  font-size: 10px;
  font-weight: 700;
}
:is(.dark) .pbi-live-badge { background: rgba(96,165,250,0.12); color: #60a5fa; }
@keyframes pbi-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%       { opacity: 0.5; transform: scale(0.8); }
}
.pbi-pulse { animation: pbi-pulse 2s ease-in-out infinite; }

/* ── Vue badge ──────────────────────────────────── */
.pbi-vue-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 999px;
  background: rgba(37,99,235,0.08);
  border: 1px solid rgba(37,99,235,0.2);
  color: #2563eb;
  font-size: 10.5px;
  font-weight: 700;
}
:is(.dark) .pbi-vue-badge { background: rgba(96,165,250,0.08); border-color: rgba(96,165,250,0.2); color: #60a5fa; }

/* ── Section title ──────────────────────────────── */
.pbi-section-title {
  font-size: 11.5px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #374151;
}
:is(.dark) .pbi-section-title { color: #d1d5db; }

/* ── Status badge ───────────────────────────────── */
.pbi-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
}
.pbi-status-badge.positive { background: #d1fae5; color: #065f46; }
.pbi-status-badge.negative { background: #fee2e2; color: #991b1b; }
:is(.dark) .pbi-status-badge.positive { background: rgba(16,185,129,0.15); color: #6ee7b7; }
:is(.dark) .pbi-status-badge.negative { background: rgba(239,68,68,0.15); color: #fca5a5; }

/* ── Filter bar ─────────────────────────────────── */
.pbi-filter-bar { background: #f9fafb; }
:is(.dark) .pbi-filter-bar { background: #0a0d14; }
.pbi-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #9ca3af;
}
.pbi-active-tag {
  background: #3b82f6;
  color: white;
  font-size: 8px;
  padding: 1px 5px;
  border-radius: 999px;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0;
}
.pbi-input {
  height: 32px;
  padding: 0 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  color: #111827;
  font-size: 12px;
  outline: none;
  width: 100%;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.pbi-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.12); }
:is(.dark) .pbi-input { border-color: rgba(255,255,255,0.1); background: #161a23; color: #e2e8f0; }
:is(.dark) .pbi-input:focus { border-color: #60a5fa; box-shadow: 0 0 0 3px rgba(96,165,250,0.12); }
.pbi-btn-filter {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: white;
  color: #4b5563;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  position: relative;
}
.pbi-btn-filter:hover, .pbi-btn-filter.active { border-color: rgba(59,130,246,0.4); background: rgba(59,130,246,0.06); color: #2563eb; }
:is(.dark) .pbi-btn-filter { border-color: rgba(255,255,255,0.1); background: #161a23; color: #9ca3af; }
:is(.dark) .pbi-btn-filter.active, :is(.dark) .pbi-btn-filter:hover { border-color: rgba(96,165,250,0.35); background: rgba(96,165,250,0.08); color: #60a5fa; }
.pbi-filter-badge {
  background: #3b82f6;
  color: white;
  font-size: 9px;
  font-weight: 800;
  width: 16px;
  height: 16px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.pbi-btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: white;
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}
.pbi-btn-ghost:hover { opacity: 0.75; }
:is(.dark) .pbi-btn-ghost { border-color: rgba(255,255,255,0.1); background: #161a23; color: #9ca3af; }

/* ── Tabs ───────────────────────────────────────── */
.pbi-tabs-nav { scrollbar-width: thin; gap: 0; }
.pbi-tab {
  flex-shrink: 0;
  padding: 10px 14px;
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
  color: #9ca3af;
}
.pbi-tab:hover { color: #374151; border-bottom-color: #e5e7eb; }
.pbi-tab.active { color: #2563eb; border-bottom-color: #2563eb; }
:is(.dark) .pbi-tab { color: #6b7280; }
:is(.dark) .pbi-tab:hover { color: #d1d5db; border-bottom-color: rgba(255,255,255,0.1); }
:is(.dark) .pbi-tab.active { color: #60a5fa; border-bottom-color: #60a5fa; }

/* ── Summary pill ───────────────────────────────── */
.pbi-summary-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 500;
  background: #f3f4f6;
  color: #6b7280;
}
:is(.dark) .pbi-summary-pill { background: rgba(255,255,255,0.05); color: #9ca3af; }

/* ── Action buttons ─────────────────────────────── */
.pbi-btn-excel {
  display: inline-flex; align-items: center; gap: 5px;
  height: 28px; padding: 0 10px; border-radius: 8px; border: none;
  background: #059669; color: white; font-size: 11px; font-weight: 600;
  cursor: pointer; transition: all 0.15s; box-shadow: 0 1px 3px rgba(5,150,105,0.3);
}
.pbi-btn-excel:hover { background: #047857; }
.pbi-btn-excel:active { transform: scale(0.96); }
.pbi-btn-print {
  display: inline-flex; align-items: center; gap: 5px;
  height: 28px; padding: 0 10px; border-radius: 8px; border: none;
  background: #2563eb; color: white; font-size: 11px; font-weight: 600;
  cursor: pointer; transition: all 0.15s; box-shadow: 0 1px 3px rgba(37,99,235,0.3);
}
.pbi-btn-print:hover { background: #1d4ed8; }
.pbi-btn-print:active { transform: scale(0.96); }

/* ── KPI Cards ──────────────────────────────────── */
.pbi-kpi-card {
  position: relative; border-radius: 12px; border: 1px solid #f3f4f6;
  background: white; padding: 16px 14px 14px; overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04); transition: box-shadow 0.2s;
}
.pbi-kpi-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.08); }
:is(.dark) .pbi-kpi-card { background: #13161f; border-color: rgba(255,255,255,0.06); }
.pbi-kpi-accent { position: absolute; top: 0; left: 0; right: 0; height: 3px; border-radius: 12px 12px 0 0; }
.pbi-kpi-icon { width: 30px; height: 30px; border-radius: 8px; display: flex; align-items: center; justify-content: center; margin-bottom: 10px; }
.pbi-kpi-label { font-size: 9.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #9ca3af; margin-bottom: 4px; }
.pbi-kpi-value { font-size: 18px; font-weight: 800; font-family: ui-monospace, monospace; line-height: 1; margin-bottom: 4px; font-variant-numeric: tabular-nums; }
.pbi-kpi-sub { font-size: 10px; color: #9ca3af; margin-top: 4px; }

/* ── Metric cards ───────────────────────────────── */
.pbi-metric-card {
  background: #f9fafb; border-radius: 12px; border: 1px solid #f3f4f6;
  padding: 12px 14px; display: flex; justify-content: space-between; align-items: center; gap: 10px;
}
:is(.dark) .pbi-metric-card { background: #13161f; border-color: rgba(255,255,255,0.06); }
.pbi-metric-label { font-size: 9.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; color: #9ca3af; margin-bottom: 3px; }
.pbi-metric-value { font-size: 13px; font-weight: 800; font-family: ui-monospace, monospace; font-variant-numeric: tabular-nums; }
.pbi-metric-icon { flex-shrink: 0; width: 32px; height: 32px; border-radius: 9px; display: flex; align-items: center; justify-content: center; }

/* ── Répartition rows ───────────────────────────── */
.pbi-rep-row { display: flex; align-items: center; gap: 10px; padding: 10px 6px; border-radius: 10px; transition: background 0.15s; flex-wrap: wrap; }
.pbi-rep-row:hover { background: #f9fafb; }
:is(.dark) .pbi-rep-row:hover { background: rgba(255,255,255,0.02); }

/* ── Table ──────────────────────────────────────── */
.pbi-th {
  padding: 9px 12px; border-bottom: 1px solid #f3f4f6;
  font-size: 9.5px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.08em; color: #9ca3af; white-space: nowrap;
}
:is(.dark) .pbi-th { border-bottom-color: rgba(255,255,255,0.06); }
.pbi-tr { border-bottom: 1px solid #f9fafb; transition: background 0.1s; }
.pbi-tr:hover { background: rgba(59,130,246,0.03); }
.pbi-tr-alt { background: rgba(249,250,251,0.6); }
:is(.dark) .pbi-tr { border-bottom-color: rgba(255,255,255,0.025); }
:is(.dark) .pbi-tr:hover { background: rgba(96,165,250,0.04); }
:is(.dark) .pbi-tr-alt { background: rgba(255,255,255,0.012); }
.pbi-td { padding: 7px 12px; vertical-align: middle; }

/* ── Lignes de groupe (CAGA groupé) ─────────────── */
.pbi-tr-group {
  background: #f0f7ff;
  border-bottom: 1px solid #dbeafe;
}
:is(.dark) .pbi-tr-group {
  background: rgba(37,99,235,0.08);
  border-bottom-color: rgba(96,165,250,0.12);
}
.pbi-td-group {
  padding: 8px 12px;
  font-size: 11px;
}
.pbi-tr-sub td { padding-left: 24px !important; }

/* ── Empty state ────────────────────────────────── */
.pbi-empty-state { padding: 56px 20px; text-align: center; color: #9ca3af; }

/* ── Pagination ─────────────────────────────────── */
.pbi-page-btn {
  padding: 5px 12px; border-radius: 8px; border: 1px solid #e5e7eb;
  background: white; color: #4b5563; font-size: 11px; font-weight: 600;
  cursor: pointer; transition: all 0.15s;
}
.pbi-page-btn:disabled { opacity: 0.3; cursor: not-allowed; }
.pbi-page-btn:not(:disabled):hover { border-color: #3b82f6; color: #2563eb; }
:is(.dark) .pbi-page-btn { border-color: rgba(255,255,255,0.08); background: #161a23; color: #9ca3af; }
:is(.dark) .pbi-page-btn:not(:disabled):hover { border-color: #60a5fa; color: #60a5fa; }
</style>